(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class ScrollingComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.scrolling-component');
      if (!container || !this.querySelector('.scrolling-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('scrolling-component--h-scroll', 'scrolling-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('scrolling-component')) customElements.define('scrolling-component', ScrollingComponent);
  if (!customElements.get('hideable-element')) {
    customElements.define('hideable-element', class HideableElement extends HTMLElement {
      constructor() {
        super();
        this.elementToHide = this.querySelector('aside');
        this.elementToggle = this.querySelector('.js-contents--btn-close');
        const hasBeenHidden = localStorage.getItem(`${this.elementToHide.id}-hidden`);
        
        if (hasBeenHidden) {
          this.elementToHide.classList.add('hidebar');
        }
        
        if(this.elementToggle){
          this.elementToggle.addEventListener('click', () => {
            this.elementToHide.style.display = 'none';
            localStorage.setItem(`${this.elementToHide.id}-hidden`, true);
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class DropdownToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.button = this.querySelector('[data-btn-toggler]');
      if(!this.button) return;
      const onHandleClick = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.parent);
        parent.classList.toggle(this.dataset.activeClass);
      }
      this.handleClick = onHandleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
    }
  }
  if(!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);
  class FiltersForm extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = [];
      
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      const filterForm = this.querySelector('form');
      filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      
      const resetBtn = document.querySelectorAll('.filters-form_remove-all');
      if(resetBtn){
        resetBtn.forEach(btn => {
          btn.addEventListener('click', this.resetFilters.bind(this));
        });
      }
      
      if(this.dataset.preserver) window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    connectedCallback(){
      const form = this.querySelector('form');
      const params = this.createSearchParams(form);
      this.initParams = params ? params : '';

      FiltersForm.checkEmptyURL();
    }
    
    onHistoryChange(){
      if(event.state && this.cachedResults.length === 0){
        const loader = document.querySelector('.filters-grid_loader');
        loader.classList.add('--show-loader');
        
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
        this.renderFetch(url, false, searchParams);
        
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const loader = document.querySelector('.filters-grid_loader');
        loader.classList.add('--show-loader');
        
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
      
        if (this.cachedResults.some(key => key.params === term.params)) {
          this.renderFromCache(this.cachedResults, term, false);
        
        } else{
          const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
          this.renderFetch(url, false, searchParams);
        }
      }
    }
    
    onSubmitHandler(){
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.add('--show-loader');
      
      const searchParams = this.createSearchParams(this.querySelector('form'));
      const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
      const term = {params: searchParams};
      
      if (this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true);
        
        return;
      }
      
      this.renderFetch(url, true, searchParams);
    }

    renderFetch(url, updateURLHash = false, searchParams){
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;

          this.renderProductGridContainer(html);
          this.renderActiveFiltersContainer(html);
          if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
          
          if(this.dataset.updateSelf === 'true'){
            this.renderFiltersList(html, true);
          
          } else{
            this.renderFiltersList(html);
          }
          
          const cacheObj = {params: searchParams, content: html};
          this.cachedResults.push(cacheObj);
          this.renderPriceUpdates(html);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          const loader = document.querySelector('.filters-grid_loader');
          loader.classList.remove('--show-loader');
          
          if(updateURLHash) this.updateURLHash(searchParams);
        });
    }
    
    renderFromCache(cache, filter, updateURLHash = false){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const html = cachedResults.content;
      
      this.renderProductGridContainer(html);
      this.renderActiveFiltersContainer(html);
      if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
          
      if(this.dataset.updateSelf === 'true'){
        this.renderFiltersList(html, true);
      
      } else{
        this.renderFiltersList(html);
      }
      
      this.renderPriceUpdates(html);
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.remove('--show-loader');
      
      if(updateURLHash) this.updateURLHash(filter.params);
    }

    createSearchParams(form) {
      const rangeSlider = document.querySelector('range-slider');
      const formData = new FormData(form);
      
      if(!rangeSlider) return new URLSearchParams(formData).toString();
      
      if(rangeSlider.dataset.load === 'false'){
        const gte = rangeSlider.querySelector('.min');
        const lte = rangeSlider.querySelector('.max');
        formData.delete(gte.getAttribute('name'));
        formData.delete(lte.getAttribute('name'));
      }
      return new URLSearchParams(formData).toString();
    }

    renderProductGridContainer(html){
      document.getElementById('filters-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('filters-grid').innerHTML;
    }

    renderPriceUpdates(html){
      const priceRange = document.getElementById('price-range');
      if(!priceRange) return;
      
      const newHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('price-range');
      const newInputs = newHtml.querySelectorAll('input');
      const oldInputs = document.querySelectorAll('#price-range input');
      
      // Instead of completely replacing innerHTML, only replace if NOT focused 
      // to preserve input focus while typing.
      const focusElementId = document.activeElement ? document.activeElement.className : null;
      
      oldInputs.forEach((input, index) => {
        if (document.activeElement !== input) {
          if (newInputs[index]) input.value = newInputs[index].value;
        }
      });

      const newCounts = newHtml.querySelector('.range_wrapper');
      const oldCounts = document.querySelector('#price-range .range_wrapper');
      if (newCounts && oldCounts) {
        const activeClasses = (document.activeElement && document.activeElement.className) || '';
        if (typeof activeClasses === 'string' && !activeClasses.includes('range_min') && !activeClasses.includes('range_max')) {
          oldCounts.innerHTML = newCounts.innerHTML;
        }
      }
    }

    renderActiveFiltersContainer(html){
      document.querySelector('.filters-head').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filters-head').innerHTML;
    }

    renderActiveCounts(html){
      document.querySelector('.filter-header_results-text').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filter-header_results-text').innerHTML;
    }

    renderFiltersList(html, collapsible = null){
      let filterWidgets = document.querySelectorAll('.filter-widget--list');
      let selector = '.filter-widget--list';
      if(collapsible){
        filterWidgets = document.querySelectorAll('.filter-widget--update');
        selector = '.filter-widget--update';
      }
      
      filterWidgets.forEach((widget, index) => {
        widget.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(selector)[index].innerHTML;
      });
    }
    
    updateURLHash(searchParams) {
      if(!searchParams) searchParams = this.initParams;
      
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
    
    resetFilters(){
      event.preventDefault();
      let filterForm = document.querySelector('filters-form[data-preserver="true"] form');
      const inputs = filterForm.querySelectorAll('input');
      
      inputs.forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      
      const priceRange = document.querySelector('range-slider');
      if(priceRange) priceRange.resetRanges();
      
      filterForm.reset();
      filterForm.dispatchEvent(new Event('input'));
    }

    static checkEmptyURL(){
      const activeFacet = document.querySelector('button-filter-remove');
      if(activeFacet){
        const filters = document.querySelector('[data-check-on-empty]');
        if(filters){
          filters.removeAttribute('hidden');
          if(filters.previousElementSibling) filters.previousElementSibling.classList.remove('--hide-separator');
        }
      }
    }
  }
  customElements.define('filters-form', FiltersForm);
  class RangeSlider extends HTMLElement {
    constructor() {
      super();
      
      this.inputs = this.querySelectorAll('input[type="range"]');
      
      if(this.inputs){
        this.inputs.forEach(input => {
          input.addEventListener('input', this.onSlideWatch.bind(this));
        });
      }

      // Delegate input change for the number inputs because they can be re-rendered
      this.addEventListener('input', (event) => {
        if(event.target.classList.contains('range_min') || event.target.classList.contains('range_max')) {
          this.onNumberInputChange(event);
        }
      });
    }
    
    onSlideWatch(event){
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');
      
      var minVal = parseFloat(minInput.value);
      var maxVal = parseFloat(maxInput.value);

      // Swap if min > max
      if (minInput && maxInput && minVal > maxVal) {
        if (event && event.target === minInput) {
          minInput.value = maxVal;
          minVal = maxVal;
        } else {
          maxInput.value = minVal;
          maxVal = minVal;
        }
      }
      
      if (rangeMin) {
        if (rangeMin.tagName === 'INPUT') {
          rangeMin.value = minVal;
        } else {
          rangeMin.innerText = Shopify.formatMoney(minVal * 100, window.money_format);
        }
      }

      if (rangeMax) {
        if (rangeMax.tagName === 'INPUT') {
          rangeMax.value = maxVal;
        } else {
          rangeMax.innerText = Shopify.formatMoney(maxVal * 100, window.money_format);
        }
      }
      
      this.setAttribute('data-load', true);
    }

    onNumberInputChange(event) {
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');

      let minVal = parseFloat(rangeMin.value) || 0;
      let maxVal = parseFloat(rangeMax.value) || 0;
      const maxAllowed = parseFloat(maxInput.max);

      if (minVal > maxAllowed) minVal = maxAllowed;
      if (maxVal > maxAllowed) maxVal = maxAllowed;

      if (minVal > maxVal) {
        if (event.target === rangeMin) {
          minVal = maxVal;
          rangeMin.value = minVal;
        } else {
          maxVal = minVal;
          rangeMax.value = maxVal;
        }
      }

      minInput.value = minVal;
      maxInput.value = maxVal;

      this.setAttribute('data-load', true);
    }
    
    resetRanges(){
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');
      
      var minVal = minInput.min;
      var maxVal = maxInput.max;
      
      minInput.value = minVal;
      maxInput.value = maxVal;
      
      if (rangeMin) {
        if (rangeMin.tagName === 'INPUT') {
          rangeMin.value = minVal;
        } else {
          rangeMin.innerText = Shopify.formatMoney(minVal * 100, window.money_format);
        }
      }

      if (rangeMax) {
        if (rangeMax.tagName === 'INPUT') {
          rangeMax.value = maxVal;
        } else {
          rangeMax.innerText = Shopify.formatMoney(maxVal * 100, window.money_format);
        }
      }
      
      this.setAttribute('data-load', false);
    }
  }
  customElements.define('range-slider', RangeSlider);
  class ButtonFilterRemove extends HTMLElement {
    constructor() {
      super();
      
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.submitRemoval.bind(this));
    }
    
    submitRemoval(){
      if(!this.dataset.for) return;
      
      const ref = this.dataset.for;
      const input = document.getElementById(ref);
      let filterForm = document.querySelector('.filters-sidebar form');
      if(this.dataset.updateId) filterForm = document.querySelector(`#${this.dataset.updateId}`);
      
      if(!input || !filterForm) return;
      
      if(ref === 'price-range'){
        const priceRange = document.getElementById(ref);
        priceRange.resetRanges();
        filterForm.dispatchEvent(new Event('input'));
        
        return;
      }
      
      input.checked = false;
      input.removeAttribute('checked');
      filterForm.dispatchEvent(new Event('input'));
    }
  }
  customElements.define('button-filter-remove', ButtonFilterRemove);
  /* ─── Filter Show-More / Show-Less ─────────────────────────────────────── */
  (function () {
    const MIN_VISIBLE = 10;
    function initList(ul) {
      const old = ul.parentElement.querySelector('.filter-show-more-wrap');
      if (old) old.remove();

      const items = Array.from(ul.querySelectorAll(':scope > li'));
      if (items.length <= MIN_VISIBLE) return;

      let expanded = false;

      items.forEach((li, i) => {
        li.style.display = i >= MIN_VISIBLE ? 'none' : '';
      });

      const wrap = document.createElement('div');
      wrap.className = 'filter-show-more-wrap';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'filter-show-more-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = `
        <span class="fsm-icon fsm-icon--plus">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
            <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="fsm-icon fsm-icon--minus" hidden>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
            <path d="M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="fsm-label"></span>
      `;

      const updateLabel = () => {
        const hidden = items.length - MIN_VISIBLE;
        btn.querySelector('.fsm-label').textContent = expanded
          ? 'Show less'
          : `Show more (${hidden})`;
        btn.querySelector('.fsm-icon--plus').hidden = expanded;
        btn.querySelector('.fsm-icon--minus').hidden = !expanded;
        btn.setAttribute('aria-expanded', String(expanded));
      };

      updateLabel();

      btn.addEventListener('click', () => {
        expanded = !expanded;
        items.forEach((li, i) => {
          if (i >= MIN_VISIBLE) li.style.display = expanded ? '' : 'none';
        });
        updateLabel();
      });

      wrap.appendChild(btn);

      ul.insertAdjacentElement('afterend', wrap);
    }

    function initAllLists(root) {
      const root$ = root || document;
      root$.querySelectorAll('.filter-widget--update').forEach(initList);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllLists());
    } else {
      initAllLists();
    }

    const sidebar = document.querySelector('.filters-sidebar') || document.querySelector('filters-form');
    if (sidebar) {
      const observerConfig = { childList: true, subtree: true };
      const observer = new MutationObserver((mutations) => {
        const isOwnChange = mutations.every(
          (m) => m.target.nodeType === Node.TEXT_NODE
                ? !!m.target.parentElement?.closest('.filter-show-more-wrap')
                : !!m.target.closest?.('.filter-show-more-wrap')
        );
        if (isOwnChange) return;

        observer.disconnect();
        initAllLists(sidebar);
        setTimeout(() => observer.observe(sidebar, observerConfig), 0);
      });
      setTimeout(() => observer.observe(sidebar, observerConfig), 0);
    }
  })();
  if (!customElements.get('product-compare-button')) {
    customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }
      
      connectedCallback(){
        this.checkComparelistStatus();
      }
      
      onCompare(){
        event.preventDefault();
        if(!this.dataset.handle) return;
        
        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;
        
        if(!compareList.includes(handle)){
        
          if(compareList.length && compareList.length >= compareLimit){
            comparelistContainer.classList.add('--limit-exceed');
            
            alert(window.additionalStrings.compare.limitExceed);
            return;
          
          } else{
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        
        } else{
          var index = compareList.indexOf(handle);
          
          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));
        
        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if(compareList.length === 0){
          modalOpener.classList.add('hidden');
        
        } else if(compareList.length === 1){
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        
        } else{
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }
        
        if(comparelistOrganizer){
          comparelistOrganizer.innerText = compareList.length;
        }
        
        this.checkComparelistStatus();
      }
      
      checkComparelistStatus(){
        if(!this.dataset.handle) return;
        
        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        
        allBtns.forEach(btn => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');
          
          if(compareList.includes(handle)){
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
          
          } else{
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
          }
        });
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smooth-anchor')) {
    customElements.define('smooth-anchor', class SmoothAnchor extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onClickRef.bind(this));
      }
      
      onClickRef(){
        event.preventDefault();
        
        const targetId = this.anchor.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if(targetElement){
          if(this.dataset.offset){
            let offset = 0;
            const offsetElement = document.querySelector(this.dataset.offset);
            if(!offsetElement){
              doScroll();
              if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
              return
            };
            const elementPosition = targetElement.getBoundingClientRect().top;
            offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
            window.scrollTo({
              top: offset,
              behavior: "smooth"
            });
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          doScroll();
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
        }
          
        function doScroll(){
          targetElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabset-component')) {
    customElements.define('tabset-component', class TabsetComponent extends HTMLElement {
      constructor() {
        super();
        
        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.initialize();
        if(this.dataset.editorMode === 'true'){
          document.addEventListener('shopify:block:select', function (event) {
            const target = event.target;
            const parent = target.parentElement;
            if(parent.nodeName !== 'TABSET-COMPONENT') return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
      }
      
      initialize(){
        this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach(tab => {
          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));
        });

        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        this.setSelectedTab(this.firstTab, false);
      }

      setSelectedTab(currentTab, setFocus = true) {
        this.tabs.forEach((tab, index) => {
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
          this.tabpanels[index].classList.toggle('hidden', !isSelected);
          if (isSelected && setFocus) {
            tab.focus();
          }
        });
      }

      setSelectedToPreviousTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      }

      setSelectedToNextTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
      }

      onKeydown(event) {
        const tgt = event.currentTarget;
        let flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class DropdownToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.button = this.querySelector('[data-btn-toggler]');
      if(!this.button) return;
      const onHandleClick = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.parent);
        parent.classList.toggle(this.dataset.activeClass);
      }
      this.handleClick = onHandleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
    }
  }
  if(!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);
  if (!customElements.get('product-compare-button')) {
    customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }
      
      connectedCallback(){
        this.checkComparelistStatus();
      }
      
      onCompare(){
        event.preventDefault();
        if(!this.dataset.handle) return;
        
        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;
        
        if(!compareList.includes(handle)){
        
          if(compareList.length && compareList.length >= compareLimit){
            comparelistContainer.classList.add('--limit-exceed');
            
            alert(window.additionalStrings.compare.limitExceed);
            return;
          
          } else{
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        
        } else{
          var index = compareList.indexOf(handle);
          
          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));
        
        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if(compareList.length === 0){
          modalOpener.classList.add('hidden');
        
        } else if(compareList.length === 1){
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        
        } else{
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }
        
        if(comparelistOrganizer){
          comparelistOrganizer.innerText = compareList.length;
        }
        
        this.checkComparelistStatus();
      }
      
      checkComparelistStatus(){
        if(!this.dataset.handle) return;
        
        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        
        allBtns.forEach(btn => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');
          
          if(compareList.includes(handle)){
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
          
          } else{
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
          }
        });
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    });
  }
  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }

      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };
  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        
        this.bundleContainer = document.querySelector('[data-bundle-product-wrapper]');
        if(this.bundleContainer) this.bundleContainer.classList.add('visually-hidden');
      }

      connectedCallback() {
        this.empty = true;
        
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.empty = false;
                this.innerHTML = recommendations.innerHTML;
                
                if(!recommendations.innerHTML.includes('<product-card')){
                  let recommendationAncestor = this.parentElement;
                  
                  while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                    recommendationAncestor = recommendationAncestor.parentElement;
                  }
                  
                  if(recommendationAncestor){
                    recommendationAncestor.classList.add('hidden');
                  }
                }
              
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              if(this.empty){
                if(this.bundleContainer) this.bundleContainer.classList.add('hidden');
                this.parentElement.classList.add('hidden');
                return;
              }
              if(this.bundleContainer) this.bundleContainer.classList.remove('visually-hidden');
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    });
  }
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('smooth-anchor')) {
    customElements.define('smooth-anchor', class SmoothAnchor extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onClickRef.bind(this));
      }
      
      onClickRef(){
        event.preventDefault();
        
        const targetId = this.anchor.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if(targetElement){
          if(this.dataset.offset){
            let offset = 0;
            const offsetElement = document.querySelector(this.dataset.offset);
            if(!offsetElement){
              doScroll();
              if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
              return
            };
            const elementPosition = targetElement.getBoundingClientRect().top;
            offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
            window.scrollTo({
              top: offset,
              behavior: "smooth"
            });
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          doScroll();
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
        }
          
        function doScroll(){
          targetElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', class StickyBlock extends HTMLElement {
      constructor() {
        super();
        
        if(!this.dataset.refBlock && !this.dataset.behavior) return;
        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }
      
      connectedCallback(){
        document.addEventListener('DOMContentLoaded', function(){this.onload;});
      }
      
      initialize(){
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        
        if(this.behavior){
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', this.onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', this.onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', this.onStackedScroll.bind(this));
              break;
            default:
              console.log('init sticky block');
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if(!this.refBlock) return;
        
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        
        if(this.spacer) this.height = this.refBlock.offsetHeight;
      }
      
      onDownwardScroll(){
        let revealedAttr = false;
        
        if(this.percent){
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = pageHeight * parseFloat(this.percent) / 100;
          this.threshold = threshold;
        }
        
        if(window.scrollY > this.threshold){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      onUpwardScroll(){
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;
        
        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
          
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          this.dropdownClose();
          
          if(window.scrollY < threshold){
            revealedAttr = false;
          }
        }
        
        this.setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      }
      
      onStackedScroll(){
        let revealedAttr = false;
        if(this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if(this.refBoundings.y < window.scrollY){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      setStickyStatus(revealed){
        if(this.dataset.hideOnEnd === 'true'){
          if((window.innerHeight + window.scrollY) >= this.endBounds){
            this.stickyHide();
            return;
          }
        }
        
        if(revealed){
          this.setAttribute('data-revealed', true);
          if(this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if(this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if(this.height){
            this.style.height = this.height + 'px';
            if(this.dataset.bodyClass) document.body.style.setProperty(this.dataset.cssVariable, this.height + 'px');
          }
          return;
        }
        
        this.stickyHide();
      }
      
      stickyHide(){
        this.setAttribute('data-revealed', false);
        if(this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if(this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if(this.height){
          this.style.removeProperty('height');
          
          if(this.dataset.bodyClass) document.body.style.removeProperty(this.dataset.cssVariable);
        }
      }
      
      dropdownClose(){
        const dropdowns = this.querySelectorAll('dropdown-component');
        if(!dropdowns) return;
        dropdowns.forEach(dropdown => {
          dropdown.close();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('accordion-wrapper')) {
    customElements.define('accordion-wrapper', class AccordionWrapper extends HTMLElement {
      constructor() {
        super();
        
        this.toggle = this.querySelector('summary');
        if(this.toggle) this.toggle.addEventListener('click', this.accordion.bind(this));
      }
      
      accordion(event){
        if(this.dataset.behavior === 'open-close') this.setEventListners();
        if(this.toggle.parentElement.hasAttribute('open') && this.dataset.behavior !== 'open-close') this.keepOpen(event);
        if(!this.toggle.parentElement.hasAttribute('open')) this.closeOther();
      }
      
      closeOther(){
        const allRows = document.querySelectorAll(`#${this.dataset.parent} details`);
        allRows.forEach(toggler => {
          if(toggler.querySelector('summary') === this.toggle && this.dataset.behavior !== 'open-close') return;
          toggler.removeAttribute('open');
        });
      }
      
      keepOpen(event){
        const toggle = event.target.closest('details');
        toggle.removeAttribute('open');
      }
      
      setEventListners(){
        document.body.addEventListener('click', this.hideOutside.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      
      hideOutside(event){
        const target = event.target;
        const boundings = this.querySelector('.collapsible-row_content');
        if (boundings.contains(target) || target === boundings || target.closest('.collapsible-row_content')) return;
        this.closeOther();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.closeOther();
      }
    });
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', class StickyBlock extends HTMLElement {
      constructor() {
        super();
        
        if(!this.dataset.refBlock && !this.dataset.behavior) return;
        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }
      
      connectedCallback(){
        document.addEventListener('DOMContentLoaded', function(){this.onload;});
      }
      
      initialize(){
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        
        if(this.behavior){
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', this.onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', this.onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', this.onStackedScroll.bind(this));
              break;
            default:
              console.log('init sticky block');
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if(!this.refBlock) return;
        
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        
        if(this.spacer) this.height = this.refBlock.offsetHeight;
      }
      
      onDownwardScroll(){
        let revealedAttr = false;
        
        if(this.percent){
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = pageHeight * parseFloat(this.percent) / 100;
          this.threshold = threshold;
        }
        
        if(window.scrollY > this.threshold){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      onUpwardScroll(){
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;
        
        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
          
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          this.dropdownClose();
          
          if(window.scrollY < threshold){
            revealedAttr = false;
          }
        }
        
        this.setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      }
      
      onStackedScroll(){
        let revealedAttr = false;
        if(this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if(this.refBoundings.y < window.scrollY){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      setStickyStatus(revealed){
        if(this.dataset.hideOnEnd === 'true'){
          if((window.innerHeight + window.scrollY) >= this.endBounds){
            this.stickyHide();
            return;
          }
        }
        
        if(revealed){
          this.setAttribute('data-revealed', true);
          if(this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if(this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if(this.height){
            this.style.height = this.height + 'px';
            if(this.dataset.bodyClass) document.body.style.setProperty(this.dataset.cssVariable, this.height + 'px');
          }
          return;
        }
        
        this.stickyHide();
      }
      
      stickyHide(){
        this.setAttribute('data-revealed', false);
        if(this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if(this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if(this.height){
          this.style.removeProperty('height');
          
          if(this.dataset.bodyClass) document.body.style.removeProperty(this.dataset.cssVariable);
        }
      }
      
      dropdownClose(){
        const dropdowns = this.querySelectorAll('dropdown-component');
        if(!dropdowns) return;
        dropdowns.forEach(dropdown => {
          dropdown.close();
        });
      }
    });
  }
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  if (!customElements.get('shipping-bar')) {
    customElements.define('shipping-bar', class ShippingBar extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback(){
        this.setString();
        this.setBar();
      }
      
      setString(){
        const dataRate = Number(this.dataset.amount);
        const rateFactor = Shopify.currency.rate || 1;
        const amountCalc = dataRate * rateFactor;
        const html = this.innerHTML;
        const cartTotals = Number(this.dataset.cartTotals) / 100;
        const amount = (amountCalc - cartTotals) * 100;
        if(amount > 0){
          this.innerHTML = html.replace(/\|\|amount\|\|/g, Shopify.formatMoney(amount, window.money_format));
        } else{
          this.firstElementChild.innerHTML = window.cartStrings.shippingAmount;
        }
        this.threshold = amountCalc;
        this.cartTotals = cartTotals;
      }
      
      setBar(){
        const element = this.querySelector('[data-set="bar"]');
        if(!element) return;
        const percent = (this.cartTotals / this.threshold) * 100;
        element.style.width = percent + '%';
      }
    });
  }
  if (!customElements.get('checkout-min')) {
    customElements.define('checkout-min', class CheckoutMin extends HTMLElement {
      constructor() {
        super();
        this.checkout = this.onCheckout.bind(this);
      }

      connectedCallback(){
        this.form = this.closest('form');
        this.button = this.querySelector('button');
        if(!this.form || !this.button) return;
        if(this.dataset.minValue === isNaN || this.dataset.cartValue === isNaN) return;
        this.onCheck();
        this.initialize();
      }

      onCheck(){
        this.form.addEventListener('submit', this.checkout);
      }

      initialize(){
        const dataRate = Number(this.dataset.amount);
        const rateFactor = Shopify.currency.rate || 1;
        const amountCalc = dataRate * rateFactor;
        const cartTotals = Number(this.dataset.cartTotals) / 100;
        this.amount = (amountCalc - cartTotals) * 100;
        const element = this.querySelector('.cart-min-value p');
        if(this.amount > 0){
          this.setStatus(false);
          element.classList.remove('hidden');
          element.innerText = element.innerText.replace('[value]', Shopify.formatMoney((amountCalc * 100), window.money_format));
          return;
        }
        element.classList.add('hidden');
        this.setStatus(true);
      }

      onCheckout(event){
        if(this.amount > 0){
          event.preventDefault();
          alert(window.cartStrings.minOrderAlert);
          return;
        }
      }

      setStatus(flag){
        if(flag) return this.button.removeAttribute('disabled');
        this.button.setAttribute('disabled', '');
      }

      removeListener(){
        this.form.removeEventListener('submit', this.checkout);
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class CartInventoryOrganizer extends HTMLElement {
    constructor() {
      super();
    }
    
    getPurposalDetails(id){
      const dataElem = this.querySelector('[type="application/json"]');
      if (!dataElem) return;
      this.data = JSON.parse(dataElem.textContent);
      
      const itemsArr = this.data.items;
      return itemsArr.find(detailsArr => {
        if(detailsArr.id === id){
          return detailsArr.id === id;
        }
      });
    }
    
    setCartUpdates(qty, selector = null){
      if(!selector) return;
      
      const elemParent = selector.parentElement;
      
      if(qty > 0){
        elemParent.classList.remove('visually-hidden');
      
      } else{
        elemParent.classList.add('visually-hidden');
      }
      
      selector.textContent = qty;
    }
    
    updateBubbleStatus(){
      const bubbles = document.querySelectorAll('[data-cart-organizer-bubble]');
      if(!bubbles || bubbles.length === 0) return;
      
      const dataElem = this.querySelector('[type="application/json"]');
      if (!dataElem) return;
      this.data = JSON.parse(dataElem.textContent);
      const regex = /\d+/;
      
      if(bubbles){
        bubbles.forEach(bubble => {
          if(bubble.getAttribute('data-cart-organizer-bubble') === 'noclass'){
            if(this.data.item_count === 1){
              bubble.innerText = window.accessibilityStrings.inCartOne.replace('[cart_count]', this.data.item_count);
            
            } else if(this.data.item_count > 1){
              bubble.innerText = window.accessibilityStrings.inCartOther.replace('[cart_count]', this.data.item_count);
            
            } else{
              bubble.innerText = window.accessibilityStrings.inCartZero;
            }
          
          } else{
            bubble.innerText = this.data.item_count;
          
            if(this.data.item_count > 0){
              bubble.classList.remove('visually-hidden');
            
            } else{
              bubble.classList.add('visually-hidden');
            }
          }
        });
      }
    }
  }
  if(!customElements.get('cart-inventory-organizer')) customElements.define('cart-inventory-organizer', CartInventoryOrganizer);
  class CartItemRow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.udpateElements = {
        mainCartItems: document.querySelector('.main-cart_items-wrap'),
        mainCartTotals: document.querySelector('[data-contents="cart-total-price"]'),
        mainCartShipmentBar: document.querySelector('[data-contents="cart-shipment-bar"]'),
        mainMinValueCheck: document.querySelector('[data-contents="main-cart-min-value-check"]'),
        drawerMinValueCheck: document.querySelector('[data-contents="drawer-min-value-check"]')
      }
      
      this.staticSelectors = {
        mcItems: '.main-cart_items-wrap',
        mcTotals: '[data-contents="cart-total-price"]',
        mcShipBar: '[data-contents="cart-shipment-bar"]',
        mainMinValue: '[data-contents="main-cart-min-value-check"]',
        drawerMinValue: '[data-contents="drawer-min-value-check"]'
      }
      
      this.quantityInput = this.querySelector('quantity-input');
      this.itemRemover = this.querySelector('.cart-item--remove');
      if (this.quantityInput) {
        this.input = this.quantityInput.querySelector('input');
        if (this.input) {
          this.initValue = this.input.value;
        }
      }
      this.productCard = document.querySelectorAll('product-card');
      this.cartInventoryOrganizer = document.querySelector('cart-inventory-organizer');
      
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', this.setCartFetchUpdates.bind(this));
      }
      if (this.itemRemover) {
        this.itemRemover.addEventListener('click', this.setCartFetchUpdates.bind(this));
      }
    }
    
    setCartFetchUpdates(event){
      const itemId = this.dataset.id;
      const qtySet = this.input ? this.input.value : 0;
      
      if(event.target === this.itemRemover || parseInt(qtySet) < 1){
        if(event.target === this.itemRemover) event.preventDefault();
        
        const qtyOffset = 0;
        this.setRenderChanges(itemId, qtyOffset);
        
        return;
      }
      
      this.setRenderChanges(itemId, qtySet);
    }
    
    setRenderChanges(line, quantity, replaceCart = false){
      this.showLoader(true);
      
      var body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      
      if(this.dataset.mainCart === 'true'){
        body = JSON.stringify({
          line,
          quantity,
          sections: this.getCartToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
      }
      
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.errors = false;
        this.handleErrors(parsedState);
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.removeListener();
          });
        }
        if(!this.errors){
          if(this.dataset.mainCart === 'true'){
            if(replaceCart){
              this.getCartToRender().forEach((section => {
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
              
              return;
            }
            if(parsedState.item_count < 1){
              this.getCartToRender().forEach((section => {
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
            } else{
              const html = new DOMParser().parseFromString(parsedState.sections['main-cart'], 'text/html');
              if(this.udpateElements.mainCartItems) this.setSectionRenderChanges(html, this.staticSelectors.mcItems, this.udpateElements.mainCartItems);
              if(this.udpateElements.mainCartTotals) this.setSectionRenderChanges(html, this.staticSelectors.mcTotals, this.udpateElements.mainCartTotals);
              if(this.udpateElements.mainCartShipmentBar) this.setSectionRenderChanges(html, this.staticSelectors.mcShipBar, this.udpateElements.mainCartShipmentBar);
              if(this.udpateElements.mainMinValueCheck) this.setSectionRenderChanges(html, this.staticSelectors.mainMinValue, this.udpateElements.mainMinValueCheck);
              
              this.getCartToRender().forEach((section => {
                if(section.section === 'main-cart') return;
                
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
            }
          
          } else{
            this.getSectionsToRender().forEach((section => {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              sectionElement.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            }));
          }
        }
        
        // publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        // console.error(e);
      })
      .finally(() => {
        if (this.input) this.initValue = this.input.value;
        
        if(!this.errors){
          if(this.productCard && this.productCard.length > 0){
            this.productCardsQtyUpdates(this.dataset.variantId);
          }
          
          this.cartInventoryOrganizer.updateBubbleStatus();
        }
        
        this.showLoader(false);
        const drawer = document.querySelector('[data-modal="modal-cart-drawer"]');
        if(drawer) trapFocus(drawer.content);
        const shippingBar = document.querySelectorAll('shipping-bar');
        if(shippingBar){
          shippingBar.forEach(bar => {
            bar.setString();
          });
        }
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.onCheck();
            checkoutMin.initialize();
          });
        }
      });
    }
    
    showLoader(arg){
      const hasLoader = this.querySelector('.--loader');
      if(hasLoader){
        arg ? this.classList.add('--show-loader') : this.classList.remove('--show-loader');
      }
      
      const cart_area = document.querySelector('.main-cart_area');
      if(!cart_area) return;
      arg ? cart_area.classList.add('--show-loader') : cart_area.classList.remove('--show-loader');
    }
    
    handleErrors(response){
      const errorContainer = this.querySelector('.cart-item-row--error');
      
      if(!errorContainer) return;
      errorContainer.innerText = '';
      errorContainer.classList.add('hidden');
      
      if(response.errors){
        errorContainer.classList.remove('hidden');
        errorContainer.innerText = response.errors;
        
        if (this.input) this.input.value = this.initValue;
        this.errors = true;
      }
    }
    
    productCardsQtyUpdates(variantId){
      this.productCard.forEach(elem => {
        if(!elem.data) return;
        
        elem.setFromCartUpdates(variantId);
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        }
      ];
    }

    getCartToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        },
        {
          id: 'main-cart',
          selector: '#main-cart',
          section: 'main-cart'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser() .parseFromString(html, 'text/html') .querySelector(selector).innerHTML;
    }
    
    setSectionRenderChanges(newHtml, name, selector){
      const newSource = newHtml.querySelector(name);
      selector.innerHTML = newSource.innerHTML;
    }
  }
  if(!customElements.get('cart-item-row')) customElements.define('cart-item-row', CartItemRow);
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.searchTerm = '';
      this.cachedResults = [];
      this.abortController = new AbortController();
      // this.resetButton = this.querySelector('button[type="reset"]');
      this.elements = {
        input: this.querySelector('input[type="search"]'),
        resetBtn: this.querySelector('.search-bar_reset-btn'),
        form: this.querySelector('form'),
        resultsContainer: this.querySelector('.search_results-container'),
        loader: this.querySelector('.search-bar_loader'),
        productResultsContainer: this.querySelector('.search-tab-products_results'),
        collectionResultsContainer: this.querySelector('.search-tab-collections_results'),
        articleResultsContainer: this.querySelector('.search-tab-articles_results')
      }
      
      this.tabsetElements = {
        tabItems: this.querySelectorAll('.search-bar_tabs-list > li > a'),
        tabContents: this.querySelectorAll('.search-tab_content')
      }
      
      this.dataSelectors = {
        products: '.--search-tab-products-data',
        collections: '.--search-tab-collections-data',
        articles: '.--search-tab-articles-data'
      }

      if (this.elements.input) {
        // this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.elements.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this))
      }
      
      this.elements.input.addEventListener('click', this.onInputClick.bind(this));
      
      this.tabsetElements.tabItems.forEach(opener => {
        opener.addEventListener('click', this.openTabContent.bind(this));
      });
      
      document.body.addEventListener('click', this.hideOutside.bind(this));
      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.closeResults();
      });
      
      if(this.elements.resetBtn) this.elements.resetBtn.addEventListener('click', this.resetForm.bind(this));
    }
    
    onInputClick(){
      if(this.cachedResults.length && this.elements.input.value.length > 0){
        this.classList.add('--show-search-results');
      }
    }
    
    hardSubmit(){
      this.elements.form.submit();
    }

    onChange() {
      const inputValueTerm = this.elements.input.value.replace(/\s/g, "");
      
      if(inputValueTerm.length > 0){
        this.searchTerm = this.elements.input.value.trim();
        
        const term = {searchTerm: this.searchTerm};
        
        if (!this.cachedResults || !this.cachedResults.some(key => key.searchTerm === term.searchTerm)) {
          this.elements.form.classList.add('--show-loader');
          
          this.fetchSearchResults(this.searchTerm);
          
          return;
        }
        
        this.getCachedResults(term, this.cachedResults);
        
        return;
      }
      
      this.resetResults();
    }
    
    fetchSearchResults(search){
      fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          search
        )}&section_id=predictive-search&resources[type]=${this.dataset.searchTypes}`,
        { signal: this.abortController.signal }
      )
      .then((response) => {
        
        if (!response.ok) {
          var error = new Error(response.status);
          console.log(error);
        }

        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        const searchObj = {
          searchTerm: this.searchTerm,
          contentHtml: html
        }
        this.cachedResults.push(searchObj);
        
        this.updateTabsData(html);
        
        this.elements.form.classList.remove('--show-loader');
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
      })
    }
    
    getCachedResults(data, cache){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.searchTerm === data.searchTerm);
      
      this.updateTabsData(cachedResults.contentHtml);
    }
    
    updateTabsData(newHtml){
      this.tabsetElements.tabItems.forEach(items => {
        items.classList.remove('active');
      });
      
      this.tabsetElements.tabContents.forEach(tabs => {
        tabs.classList.remove('--active-tab');
      });
      
      const productsListHtml = newHtml.querySelector(this.dataSelectors.products);
      const collectionsListHtml = newHtml.querySelector(this.dataSelectors.collections);
      const articlesListHtml = newHtml.querySelector(this.dataSelectors.articles);
      
      if(productsListHtml) this.getHtmlToRender(this.elements.productResultsContainer, productsListHtml);
      if(collectionsListHtml) this.getHtmlToRender(this.elements.collectionResultsContainer, collectionsListHtml);
      if(articlesListHtml) this.getHtmlToRender(this.elements.articleResultsContainer, articlesListHtml);
      
      this.dataCheckToActiveTab(productsListHtml, collectionsListHtml, articlesListHtml);
      
      if(this.elements.resultsContainer) this.elements.resultsContainer.classList.remove('--show-loader');
      this.classList.add('--show-search-results');
      
      const hardSubmitBtn = this.querySelectorAll('.predictive-search_show-btn');
      if(hardSubmitBtn){
        hardSubmitBtn.forEach(btnSubmit => {
          btnSubmit.addEventListener('click', this.hardSubmit.bind(this));
        });
      }
    }
    
    dataCheckToActiveTab(product, collection, articles){
      if(product){
        
        if(!product.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[0].classList.add('active');
          this.tabsetElements.tabItems[0].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[0].classList.add('--active-tab');
        }
      }
      
      if(collection){
        
        if(product.classList.contains('--no-search-data') && !collection.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[1].classList.add('active');
          this.tabsetElements.tabItems[1].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[1].classList.add('--active-tab');
        }
      }
      
      if(articles){
        
        if(product.classList.contains('--no-search-data') && collection.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[2].classList.add('active');
          this.tabsetElements.tabItems[2].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[2].classList.add('--active-tab');
        }
      }
    }
    
    getHtmlToRender(selector, newHtml){
      selector.innerHTML = newHtml.outerHTML;
    }
    
    openTabContent(){
      event.preventDefault();
      
      this.tabsetElements.tabItems.forEach(items => {
        items.classList.remove('active');
        items.setAttribute('aria-selected', false);
      });
      
      this.tabsetElements.tabContents.forEach(tabs => {
        tabs.classList.remove('--active-tab');
      });
      
      const url = new URL(event.target.href);
      const ref = url.hash.substring(1)
      const tabc = document.getElementById(ref);
      
      event.target.classList.add('active');
      event.target.setAttribute('aria-selected', true);
      tabc.classList.add('--active-tab');
    }
    
    closeResults(){
      this.classList.remove('--show-search-results');
    }
    
    hideOutside(){
      const target = event.target;
      if (target != this && target.id != 'search-bar' && (!this.contains(event.target)) && this.classList.contains('--show-search-results')){
        this.closeResults();
      }
    }
    
    resetResults(){
      this.classList.remove('--show-search-results');
      this.elements.productResultsContainer.innerHTML = '';
      this.elements.collectionResultsContainer.innerHTML = '';
    }
    
    resetForm(){
      event.preventDefault();
      
      this.closeResults();
      this.elements.form.reset();
      this.elements.productResultsContainer.innerHTML = '';
      this.elements.collectionResultsContainer.innerHTML = '';
      
      this.elements.input.focus();
    }
  }
  if(!customElements.get('search-form')) customElements.define('search-form', SearchForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class ScrollingComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.scrolling-component');
      if (!container || !this.querySelector('.scrolling-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('scrolling-component--h-scroll', 'scrolling-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('scrolling-component')) customElements.define('scrolling-component', ScrollingComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  const selectors = {
    customerAddresses: '[data-customer-addresses]',
    addressCountrySelect: '[data-address-country-select]',
    addressContainer: '[data-address]',
    toggleAddressButton: 'button[aria-expanded]',
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: 'button[data-confirm-message]',
  };

  const attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message',
  };

  class CustomerAddresses {
    constructor() {
      this.elements = this._getElements();
      if (Object.keys(this.elements).length === 0) return;
      this._setupCountries();
      this._setupEventListeners();
    }

    _getElements() {
      const container = document.querySelector(selectors.customerAddresses);
      return container
        ? {
            container,
            addressContainer: container.querySelector(selectors.addressContainer),
            toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
            cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
            deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
            countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
          }
        : {};
    }

    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        });
        this.elements.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
            hideElement: `AddressProvinceContainer_${formId}`,
          });
        });
      }
    }

    _setupEventListeners() {
      this.elements.toggleButtons.forEach((element) => {
        element.addEventListener('click', this._handleAddEditButtonClick);
      });
      this.elements.cancelButtons.forEach((element) => {
        element.addEventListener('click', this._handleCancelButtonClick);
      });
      this.elements.deleteButtons.forEach((element) => {
        element.addEventListener('click', this._handleDeleteButtonClick);
      });
    }

    _toggleExpanded(target) {
      target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
    }

    _handleAddEditButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);
    };

    _handleCancelButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
    };

    _handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: 'delete' },
        });
      }
    };
  }
  window.addEventListener('load', () => {
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        
        this.bundleContainer = document.querySelector('[data-bundle-product-wrapper]');
        if(this.bundleContainer) this.bundleContainer.classList.add('visually-hidden');
      }

      connectedCallback() {
        this.empty = true;
        
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.empty = false;
                this.innerHTML = recommendations.innerHTML;
                
                if(!recommendations.innerHTML.includes('<product-card')){
                  let recommendationAncestor = this.parentElement;
                  
                  while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                    recommendationAncestor = recommendationAncestor.parentElement;
                  }
                  
                  if(recommendationAncestor){
                    recommendationAncestor.classList.add('hidden');
                  }
                }
              
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              if(this.empty){
                if(this.bundleContainer) this.bundleContainer.classList.add('hidden');
                this.parentElement.classList.add('hidden');
                return;
              }
              if(this.bundleContainer) this.bundleContainer.classList.remove('visually-hidden');
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  if (!customElements.get('product-compare-button')) {
    customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }
      
      connectedCallback(){
        this.checkComparelistStatus();
      }
      
      onCompare(){
        event.preventDefault();
        if(!this.dataset.handle) return;
        
        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;
        
        if(!compareList.includes(handle)){
        
          if(compareList.length && compareList.length >= compareLimit){
            comparelistContainer.classList.add('--limit-exceed');
            
            alert(window.additionalStrings.compare.limitExceed);
            return;
          
          } else{
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        
        } else{
          var index = compareList.indexOf(handle);
          
          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));
        
        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if(compareList.length === 0){
          modalOpener.classList.add('hidden');
        
        } else if(compareList.length === 1){
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        
        } else{
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }
        
        if(comparelistOrganizer){
          comparelistOrganizer.innerText = compareList.length;
        }
        
        this.checkComparelistStatus();
      }
      
      checkComparelistStatus(){
        if(!this.dataset.handle) return;
        
        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        
        allBtns.forEach(btn => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');
          
          if(compareList.includes(handle)){
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
          
          } else{
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
          }
        });
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('shipping-bar')) {
    customElements.define('shipping-bar', class ShippingBar extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback(){
        this.setString();
        this.setBar();
      }
      
      setString(){
        const dataRate = Number(this.dataset.amount);
        const rateFactor = Shopify.currency.rate || 1;
        const amountCalc = dataRate * rateFactor;
        const html = this.innerHTML;
        const cartTotals = Number(this.dataset.cartTotals) / 100;
        const amount = (amountCalc - cartTotals) * 100;
        if(amount > 0){
          this.innerHTML = html.replace(/\|\|amount\|\|/g, Shopify.formatMoney(amount, window.money_format));
        } else{
          this.firstElementChild.innerHTML = window.cartStrings.shippingAmount;
        }
        this.threshold = amountCalc;
        this.cartTotals = cartTotals;
      }
      
      setBar(){
        const element = this.querySelector('[data-set="bar"]');
        if(!element) return;
        const percent = (this.cartTotals / this.threshold) * 100;
        element.style.width = percent + '%';
      }
    });
  }
  if (!customElements.get('checkout-min')) {
    customElements.define('checkout-min', class CheckoutMin extends HTMLElement {
      constructor() {
        super();
        this.checkout = this.onCheckout.bind(this);
      }

      connectedCallback(){
        this.form = this.closest('form');
        this.button = this.querySelector('button');
        if(!this.form || !this.button) return;
        if(this.dataset.minValue === isNaN || this.dataset.cartValue === isNaN) return;
        this.onCheck();
        this.initialize();
      }

      onCheck(){
        this.form.addEventListener('submit', this.checkout);
      }

      initialize(){
        const dataRate = Number(this.dataset.amount);
        const rateFactor = Shopify.currency.rate || 1;
        const amountCalc = dataRate * rateFactor;
        const cartTotals = Number(this.dataset.cartTotals) / 100;
        this.amount = (amountCalc - cartTotals) * 100;
        const element = this.querySelector('.cart-min-value p');
        if(this.amount > 0){
          this.setStatus(false);
          element.classList.remove('hidden');
          element.innerText = element.innerText.replace('[value]', Shopify.formatMoney((amountCalc * 100), window.money_format));
          return;
        }
        element.classList.add('hidden');
        this.setStatus(true);
      }

      onCheckout(event){
        if(this.amount > 0){
          event.preventDefault();
          alert(window.cartStrings.minOrderAlert);
          return;
        }
      }

      setStatus(flag){
        if(flag) return this.button.removeAttribute('disabled');
        this.button.setAttribute('disabled', '');
      }

      removeListener(){
        this.form.removeEventListener('submit', this.checkout);
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class CartInventoryOrganizer extends HTMLElement {
    constructor() {
      super();
    }
    
    getPurposalDetails(id){
      const dataElem = this.querySelector('[type="application/json"]');
      if (!dataElem) return;
      this.data = JSON.parse(dataElem.textContent);
      
      const itemsArr = this.data.items;
      return itemsArr.find(detailsArr => {
        if(detailsArr.id === id){
          return detailsArr.id === id;
        }
      });
    }
    
    setCartUpdates(qty, selector = null){
      if(!selector) return;
      
      const elemParent = selector.parentElement;
      
      if(qty > 0){
        elemParent.classList.remove('visually-hidden');
      
      } else{
        elemParent.classList.add('visually-hidden');
      }
      
      selector.textContent = qty;
    }
    
    updateBubbleStatus(){
      const bubbles = document.querySelectorAll('[data-cart-organizer-bubble]');
      if(!bubbles || bubbles.length === 0) return;
      
      const dataElem = this.querySelector('[type="application/json"]');
      if (!dataElem) return;
      this.data = JSON.parse(dataElem.textContent);
      const regex = /\d+/;
      
      if(bubbles){
        bubbles.forEach(bubble => {
          if(bubble.getAttribute('data-cart-organizer-bubble') === 'noclass'){
            if(this.data.item_count === 1){
              bubble.innerText = window.accessibilityStrings.inCartOne.replace('[cart_count]', this.data.item_count);
            
            } else if(this.data.item_count > 1){
              bubble.innerText = window.accessibilityStrings.inCartOther.replace('[cart_count]', this.data.item_count);
            
            } else{
              bubble.innerText = window.accessibilityStrings.inCartZero;
            }
          
          } else{
            bubble.innerText = this.data.item_count;
          
            if(this.data.item_count > 0){
              bubble.classList.remove('visually-hidden');
            
            } else{
              bubble.classList.add('visually-hidden');
            }
          }
        });
      }
    }
  }
  if(!customElements.get('cart-inventory-organizer')) customElements.define('cart-inventory-organizer', CartInventoryOrganizer);
  class CartItemRow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.udpateElements = {
        mainCartItems: document.querySelector('.main-cart_items-wrap'),
        mainCartTotals: document.querySelector('[data-contents="cart-total-price"]'),
        mainCartShipmentBar: document.querySelector('[data-contents="cart-shipment-bar"]'),
        mainMinValueCheck: document.querySelector('[data-contents="main-cart-min-value-check"]'),
        drawerMinValueCheck: document.querySelector('[data-contents="drawer-min-value-check"]')
      }
      
      this.staticSelectors = {
        mcItems: '.main-cart_items-wrap',
        mcTotals: '[data-contents="cart-total-price"]',
        mcShipBar: '[data-contents="cart-shipment-bar"]',
        mainMinValue: '[data-contents="main-cart-min-value-check"]',
        drawerMinValue: '[data-contents="drawer-min-value-check"]'
      }
      
      this.quantityInput = this.querySelector('quantity-input');
      this.itemRemover = this.querySelector('.cart-item--remove');
      if (this.quantityInput) {
        this.input = this.quantityInput.querySelector('input');
        if (this.input) {
          this.initValue = this.input.value;
        }
      }
      this.productCard = document.querySelectorAll('product-card');
      this.cartInventoryOrganizer = document.querySelector('cart-inventory-organizer');
      
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', this.setCartFetchUpdates.bind(this));
      }
      if (this.itemRemover) {
        this.itemRemover.addEventListener('click', this.setCartFetchUpdates.bind(this));
      }
    }
    
    setCartFetchUpdates(event){
      const itemId = this.dataset.id;
      const qtySet = this.input ? this.input.value : 0;
      
      if(event.target === this.itemRemover || parseInt(qtySet) < 1){
        if(event.target === this.itemRemover) event.preventDefault();
        
        const qtyOffset = 0;
        this.setRenderChanges(itemId, qtyOffset);
        
        return;
      }
      
      this.setRenderChanges(itemId, qtySet);
    }
    
    setRenderChanges(line, quantity, replaceCart = false){
      this.showLoader(true);
      
      var body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      
      if(this.dataset.mainCart === 'true'){
        body = JSON.stringify({
          line,
          quantity,
          sections: this.getCartToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
      }
      
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.errors = false;
        this.handleErrors(parsedState);
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.removeListener();
          });
        }
        if(!this.errors){
          if(this.dataset.mainCart === 'true'){
            if(replaceCart){
              this.getCartToRender().forEach((section => {
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
              
              return;
            }
            if(parsedState.item_count < 1){
              this.getCartToRender().forEach((section => {
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
            } else{
              const html = new DOMParser().parseFromString(parsedState.sections['main-cart'], 'text/html');
              if(this.udpateElements.mainCartItems) this.setSectionRenderChanges(html, this.staticSelectors.mcItems, this.udpateElements.mainCartItems);
              if(this.udpateElements.mainCartTotals) this.setSectionRenderChanges(html, this.staticSelectors.mcTotals, this.udpateElements.mainCartTotals);
              if(this.udpateElements.mainCartShipmentBar) this.setSectionRenderChanges(html, this.staticSelectors.mcShipBar, this.udpateElements.mainCartShipmentBar);
              if(this.udpateElements.mainMinValueCheck) this.setSectionRenderChanges(html, this.staticSelectors.mainMinValue, this.udpateElements.mainMinValueCheck);
              
              this.getCartToRender().forEach((section => {
                if(section.section === 'main-cart') return;
                
                const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                sectionElement.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }));
            }
          
          } else{
            this.getSectionsToRender().forEach((section => {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              sectionElement.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            }));
          }
        }
        
        // publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        // console.error(e);
      })
      .finally(() => {
        if (this.input) this.initValue = this.input.value;
        
        if(!this.errors){
          if(this.productCard && this.productCard.length > 0){
            this.productCardsQtyUpdates(this.dataset.variantId);
          }
          
          this.cartInventoryOrganizer.updateBubbleStatus();
        }
        
        this.showLoader(false);
        const drawer = document.querySelector('[data-modal="modal-cart-drawer"]');
        if(drawer) trapFocus(drawer.content);
        const shippingBar = document.querySelectorAll('shipping-bar');
        if(shippingBar){
          shippingBar.forEach(bar => {
            bar.setString();
          });
        }
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.onCheck();
            checkoutMin.initialize();
          });
        }
      });
    }
    
    showLoader(arg){
      const hasLoader = this.querySelector('.--loader');
      if(hasLoader){
        arg ? this.classList.add('--show-loader') : this.classList.remove('--show-loader');
      }
      
      const cart_area = document.querySelector('.main-cart_area');
      if(!cart_area) return;
      arg ? cart_area.classList.add('--show-loader') : cart_area.classList.remove('--show-loader');
    }
    
    handleErrors(response){
      const errorContainer = this.querySelector('.cart-item-row--error');
      
      if(!errorContainer) return;
      errorContainer.innerText = '';
      errorContainer.classList.add('hidden');
      
      if(response.errors){
        errorContainer.classList.remove('hidden');
        errorContainer.innerText = response.errors;
        
        if (this.input) this.input.value = this.initValue;
        this.errors = true;
      }
    }
    
    productCardsQtyUpdates(variantId){
      this.productCard.forEach(elem => {
        if(!elem.data) return;
        
        elem.setFromCartUpdates(variantId);
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        }
      ];
    }

    getCartToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        },
        {
          id: 'main-cart',
          selector: '#main-cart',
          section: 'main-cart'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser() .parseFromString(html, 'text/html') .querySelector(selector).innerHTML;
    }
    
    setSectionRenderChanges(newHtml, name, selector){
      const newSource = newHtml.querySelector(name);
      selector.innerHTML = newSource.innerHTML;
    }
  }
  if(!customElements.get('cart-item-row')) customElements.define('cart-item-row', CartItemRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  if (!customElements.get('smooth-anchor')) {
    customElements.define('smooth-anchor', class SmoothAnchor extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onClickRef.bind(this));
      }
      
      onClickRef(){
        event.preventDefault();
        
        const targetId = this.anchor.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if(targetElement){
          if(this.dataset.offset){
            let offset = 0;
            const offsetElement = document.querySelector(this.dataset.offset);
            if(!offsetElement){
              doScroll();
              if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
              return
            };
            const elementPosition = targetElement.getBoundingClientRect().top;
            offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
            window.scrollTo({
              top: offset,
              behavior: "smooth"
            });
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          doScroll();
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
        }
          
        function doScroll(){
          targetElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  }
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
    if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    });
  }
  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }

      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };
  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', class StickyBlock extends HTMLElement {
      constructor() {
        super();
        
        if(!this.dataset.refBlock && !this.dataset.behavior) return;
        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }
      
      connectedCallback(){
        document.addEventListener('DOMContentLoaded', function(){this.onload;});
      }
      
      initialize(){
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        
        if(this.behavior){
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', this.onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', this.onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', this.onStackedScroll.bind(this));
              break;
            default:
              console.log('init sticky block');
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if(!this.refBlock) return;
        
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        
        if(this.spacer) this.height = this.refBlock.offsetHeight;
      }
      
      onDownwardScroll(){
        let revealedAttr = false;
        
        if(this.percent){
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = pageHeight * parseFloat(this.percent) / 100;
          this.threshold = threshold;
        }
        
        if(window.scrollY > this.threshold){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      onUpwardScroll(){
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;
        
        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
          
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          this.dropdownClose();
          
          if(window.scrollY < threshold){
            revealedAttr = false;
          }
        }
        
        this.setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      }
      
      onStackedScroll(){
        let revealedAttr = false;
        if(this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if(this.refBoundings.y < window.scrollY){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      setStickyStatus(revealed){
        if(this.dataset.hideOnEnd === 'true'){
          if((window.innerHeight + window.scrollY) >= this.endBounds){
            this.stickyHide();
            return;
          }
        }
        
        if(revealed){
          this.setAttribute('data-revealed', true);
          if(this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if(this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if(this.height){
            this.style.height = this.height + 'px';
            if(this.dataset.bodyClass) document.body.style.setProperty(this.dataset.cssVariable, this.height + 'px');
          }
          return;
        }
        
        this.stickyHide();
      }
      
      stickyHide(){
        this.setAttribute('data-revealed', false);
        if(this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if(this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if(this.height){
          this.style.removeProperty('height');
          
          if(this.dataset.bodyClass) document.body.style.removeProperty(this.dataset.cssVariable);
        }
      }
      
      dropdownClose(){
        const dropdowns = this.querySelectorAll('dropdown-component');
        if(!dropdowns) return;
        dropdowns.forEach(dropdown => {
          dropdown.close();
        });
      }
    });
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        
        this.bundleContainer = document.querySelector('[data-bundle-product-wrapper]');
        if(this.bundleContainer) this.bundleContainer.classList.add('visually-hidden');
      }

      connectedCallback() {
        this.empty = true;
        
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.empty = false;
                this.innerHTML = recommendations.innerHTML;
                
                if(!recommendations.innerHTML.includes('<product-card')){
                  let recommendationAncestor = this.parentElement;
                  
                  while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                    recommendationAncestor = recommendationAncestor.parentElement;
                  }
                  
                  if(recommendationAncestor){
                    recommendationAncestor.classList.add('hidden');
                  }
                }
              
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              if(this.empty){
                if(this.bundleContainer) this.bundleContainer.classList.add('hidden');
                this.parentElement.classList.add('hidden');
                return;
              }
              if(this.bundleContainer) this.bundleContainer.classList.remove('visually-hidden');
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    });
  }
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  if (!customElements.get('product-compare-button')) {
    customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }
      
      connectedCallback(){
        this.checkComparelistStatus();
      }
      
      onCompare(){
        event.preventDefault();
        if(!this.dataset.handle) return;
        
        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;
        
        if(!compareList.includes(handle)){
        
          if(compareList.length && compareList.length >= compareLimit){
            comparelistContainer.classList.add('--limit-exceed');
            
            alert(window.additionalStrings.compare.limitExceed);
            return;
          
          } else{
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        
        } else{
          var index = compareList.indexOf(handle);
          
          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));
        
        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if(compareList.length === 0){
          modalOpener.classList.add('hidden');
        
        } else if(compareList.length === 1){
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        
        } else{
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }
        
        if(comparelistOrganizer){
          comparelistOrganizer.innerText = compareList.length;
        }
        
        this.checkComparelistStatus();
      }
      
      checkComparelistStatus(){
        if(!this.dataset.handle) return;
        
        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        
        allBtns.forEach(btn => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');
          
          if(compareList.includes(handle)){
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
          
          } else{
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
          }
        });
      }
    })
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  if (!customElements.get('smooth-anchor')) {
    customElements.define('smooth-anchor', class SmoothAnchor extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onClickRef.bind(this));
      }
      
      onClickRef(){
        event.preventDefault();
        
        const targetId = this.anchor.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if(targetElement){
          if(this.dataset.offset){
            let offset = 0;
            const offsetElement = document.querySelector(this.dataset.offset);
            if(!offsetElement){
              doScroll();
              if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
              return
            };
            const elementPosition = targetElement.getBoundingClientRect().top;
            offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
            window.scrollTo({
              top: offset,
              behavior: "smooth"
            });
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          doScroll();
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
        }
          
        function doScroll(){
          targetElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class DropdownToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.button = this.querySelector('[data-btn-toggler]');
      if(!this.button) return;
      const onHandleClick = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.parent);
        parent.classList.toggle(this.dataset.activeClass);
      }
      this.handleClick = onHandleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
    }
  }
  if(!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);
  class FiltersForm extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = [];
      
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      const filterForm = this.querySelector('form');
      filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      
      const resetBtn = document.querySelectorAll('.filters-form_remove-all');
      if(resetBtn){
        resetBtn.forEach(btn => {
          btn.addEventListener('click', this.resetFilters.bind(this));
        });
      }
      
      if(this.dataset.preserver) window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    connectedCallback(){
      const form = this.querySelector('form');
      const params = this.createSearchParams(form);
      this.initParams = params ? params : '';

      FiltersForm.checkEmptyURL();
    }
    
    onHistoryChange(){
      if(event.state && this.cachedResults.length === 0){
        const loader = document.querySelector('.filters-grid_loader');
        loader.classList.add('--show-loader');
        
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
        this.renderFetch(url, false, searchParams);
        
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const loader = document.querySelector('.filters-grid_loader');
        loader.classList.add('--show-loader');
        
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
      
        if (this.cachedResults.some(key => key.params === term.params)) {
          this.renderFromCache(this.cachedResults, term, false);
        
        } else{
          const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
          this.renderFetch(url, false, searchParams);
        }
      }
    }
    
    onSubmitHandler(){
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.add('--show-loader');
      
      const searchParams = this.createSearchParams(this.querySelector('form'));
      const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
      const term = {params: searchParams};
      
      if (this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true);
        
        return;
      }
      
      this.renderFetch(url, true, searchParams);
    }

    renderFetch(url, updateURLHash = false, searchParams){
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;

          this.renderProductGridContainer(html);
          this.renderActiveFiltersContainer(html);
          if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
          
          if(this.dataset.updateSelf === 'true'){
            this.renderFiltersList(html, true);
          
          } else{
            this.renderFiltersList(html);
          }
          
          const cacheObj = {params: searchParams, content: html};
          this.cachedResults.push(cacheObj);
          this.renderPriceUpdates(html);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          const loader = document.querySelector('.filters-grid_loader');
          loader.classList.remove('--show-loader');
          
          if(updateURLHash) this.updateURLHash(searchParams);
        });
    }
    
    renderFromCache(cache, filter, updateURLHash = false){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const html = cachedResults.content;
      
      this.renderProductGridContainer(html);
      this.renderActiveFiltersContainer(html);
      if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
          
      if(this.dataset.updateSelf === 'true'){
        this.renderFiltersList(html, true);
      
      } else{
        this.renderFiltersList(html);
      }
      
      this.renderPriceUpdates(html);
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.remove('--show-loader');
      
      if(updateURLHash) this.updateURLHash(filter.params);
    }

    createSearchParams(form) {
      const rangeSlider = document.querySelector('range-slider');
      const formData = new FormData(form);
      
      if(!rangeSlider) return new URLSearchParams(formData).toString();
      
      if(rangeSlider.dataset.load === 'false'){
        const gte = rangeSlider.querySelector('.min');
        const lte = rangeSlider.querySelector('.max');
        formData.delete(gte.getAttribute('name'));
        formData.delete(lte.getAttribute('name'));
      }
      return new URLSearchParams(formData).toString();
    }

    renderProductGridContainer(html){
      document.getElementById('filters-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('filters-grid').innerHTML;
    }

    renderPriceUpdates(html){
      const priceRange = document.getElementById('price-range');
      if(!priceRange) return;
      
      const newHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('price-range');
      const newInputs = newHtml.querySelectorAll('input');
      const oldInputs = document.querySelectorAll('#price-range input');
      
      // Instead of completely replacing innerHTML, only replace if NOT focused 
      // to preserve input focus while typing.
      const focusElementId = document.activeElement ? document.activeElement.className : null;
      
      oldInputs.forEach((input, index) => {
        if (document.activeElement !== input) {
          if (newInputs[index]) input.value = newInputs[index].value;
        }
      });

      const newCounts = newHtml.querySelector('.range_wrapper');
      const oldCounts = document.querySelector('#price-range .range_wrapper');
      if (newCounts && oldCounts) {
        const activeClasses = (document.activeElement && document.activeElement.className) || '';
        if (typeof activeClasses === 'string' && !activeClasses.includes('range_min') && !activeClasses.includes('range_max')) {
          oldCounts.innerHTML = newCounts.innerHTML;
        }
      }
    }

    renderActiveFiltersContainer(html){
      document.querySelector('.filters-head').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filters-head').innerHTML;
    }

    renderActiveCounts(html){
      document.querySelector('.filter-header_results-text').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filter-header_results-text').innerHTML;
    }

    renderFiltersList(html, collapsible = null){
      let filterWidgets = document.querySelectorAll('.filter-widget--list');
      let selector = '.filter-widget--list';
      if(collapsible){
        filterWidgets = document.querySelectorAll('.filter-widget--update');
        selector = '.filter-widget--update';
      }
      
      filterWidgets.forEach((widget, index) => {
        widget.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(selector)[index].innerHTML;
      });
    }
    
    updateURLHash(searchParams) {
      if(!searchParams) searchParams = this.initParams;
      
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
    
    resetFilters(){
      event.preventDefault();
      let filterForm = document.querySelector('filters-form[data-preserver="true"] form');
      const inputs = filterForm.querySelectorAll('input');
      
      inputs.forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      
      const priceRange = document.querySelector('range-slider');
      if(priceRange) priceRange.resetRanges();
      
      filterForm.reset();
      filterForm.dispatchEvent(new Event('input'));
    }

    static checkEmptyURL(){
      const activeFacet = document.querySelector('button-filter-remove');
      if(activeFacet){
        const filters = document.querySelector('[data-check-on-empty]');
        if(filters){
          filters.removeAttribute('hidden');
          if(filters.previousElementSibling) filters.previousElementSibling.classList.remove('--hide-separator');
        }
      }
    }
  }
  customElements.define('filters-form', FiltersForm);
  class RangeSlider extends HTMLElement {
    constructor() {
      super();
      
      this.inputs = this.querySelectorAll('input[type="range"]');
      
      if(this.inputs){
        this.inputs.forEach(input => {
          input.addEventListener('input', this.onSlideWatch.bind(this));
        });
      }

      // Delegate input change for the number inputs because they can be re-rendered
      this.addEventListener('input', (event) => {
        if(event.target.classList.contains('range_min') || event.target.classList.contains('range_max')) {
          this.onNumberInputChange(event);
        }
      });
    }
    
    onSlideWatch(event){
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');
      
      var minVal = parseFloat(minInput.value);
      var maxVal = parseFloat(maxInput.value);

      // Swap if min > max
      if (minInput && maxInput && minVal > maxVal) {
        if (event && event.target === minInput) {
          minInput.value = maxVal;
          minVal = maxVal;
        } else {
          maxInput.value = minVal;
          maxVal = minVal;
        }
      }
      
      if (rangeMin) {
        if (rangeMin.tagName === 'INPUT') {
          rangeMin.value = minVal;
        } else {
          rangeMin.innerText = Shopify.formatMoney(minVal * 100, window.money_format);
        }
      }

      if (rangeMax) {
        if (rangeMax.tagName === 'INPUT') {
          rangeMax.value = maxVal;
        } else {
          rangeMax.innerText = Shopify.formatMoney(maxVal * 100, window.money_format);
        }
      }
      
      this.setAttribute('data-load', true);
    }

    onNumberInputChange(event) {
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');

      let minVal = parseFloat(rangeMin.value) || 0;
      let maxVal = parseFloat(rangeMax.value) || 0;
      const maxAllowed = parseFloat(maxInput.max);

      if (minVal > maxAllowed) minVal = maxAllowed;
      if (maxVal > maxAllowed) maxVal = maxAllowed;

      if (minVal > maxVal) {
        if (event.target === rangeMin) {
          minVal = maxVal;
          rangeMin.value = minVal;
        } else {
          maxVal = minVal;
          rangeMax.value = maxVal;
        }
      }

      minInput.value = minVal;
      maxInput.value = maxVal;

      this.setAttribute('data-load', true);
    }
    
    resetRanges(){
      const minInput = this.querySelector('.min');
      const maxInput = this.querySelector('.max');
      const rangeMin = this.querySelector('.range_min');
      const rangeMax = this.querySelector('.range_max');
      
      var minVal = minInput.min;
      var maxVal = maxInput.max;
      
      minInput.value = minVal;
      maxInput.value = maxVal;
      
      if (rangeMin) {
        if (rangeMin.tagName === 'INPUT') {
          rangeMin.value = minVal;
        } else {
          rangeMin.innerText = Shopify.formatMoney(minVal * 100, window.money_format);
        }
      }

      if (rangeMax) {
        if (rangeMax.tagName === 'INPUT') {
          rangeMax.value = maxVal;
        } else {
          rangeMax.innerText = Shopify.formatMoney(maxVal * 100, window.money_format);
        }
      }
      
      this.setAttribute('data-load', false);
    }
  }
  customElements.define('range-slider', RangeSlider);
  class ButtonFilterRemove extends HTMLElement {
    constructor() {
      super();
      
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.submitRemoval.bind(this));
    }
    
    submitRemoval(){
      if(!this.dataset.for) return;
      
      const ref = this.dataset.for;
      const input = document.getElementById(ref);
      let filterForm = document.querySelector('.filters-sidebar form');
      if(this.dataset.updateId) filterForm = document.querySelector(`#${this.dataset.updateId}`);
      
      if(!input || !filterForm) return;
      
      if(ref === 'price-range'){
        const priceRange = document.getElementById(ref);
        priceRange.resetRanges();
        filterForm.dispatchEvent(new Event('input'));
        
        return;
      }
      
      input.checked = false;
      input.removeAttribute('checked');
      filterForm.dispatchEvent(new Event('input'));
    }
  }
  customElements.define('button-filter-remove', ButtonFilterRemove);
  /* ─── Filter Show-More / Show-Less ─────────────────────────────────────── */
  (function () {
    const MIN_VISIBLE = 10;
    function initList(ul) {
      const old = ul.parentElement.querySelector('.filter-show-more-wrap');
      if (old) old.remove();

      const items = Array.from(ul.querySelectorAll(':scope > li'));
      if (items.length <= MIN_VISIBLE) return;

      let expanded = false;

      items.forEach((li, i) => {
        li.style.display = i >= MIN_VISIBLE ? 'none' : '';
      });

      const wrap = document.createElement('div');
      wrap.className = 'filter-show-more-wrap';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'filter-show-more-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = `
        <span class="fsm-icon fsm-icon--plus">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
            <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="fsm-icon fsm-icon--minus" hidden>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
            <path d="M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="fsm-label"></span>
      `;

      const updateLabel = () => {
        const hidden = items.length - MIN_VISIBLE;
        btn.querySelector('.fsm-label').textContent = expanded
          ? 'Show less'
          : `Show more (${hidden})`;
        btn.querySelector('.fsm-icon--plus').hidden = expanded;
        btn.querySelector('.fsm-icon--minus').hidden = !expanded;
        btn.setAttribute('aria-expanded', String(expanded));
      };

      updateLabel();

      btn.addEventListener('click', () => {
        expanded = !expanded;
        items.forEach((li, i) => {
          if (i >= MIN_VISIBLE) li.style.display = expanded ? '' : 'none';
        });
        updateLabel();
      });

      wrap.appendChild(btn);

      ul.insertAdjacentElement('afterend', wrap);
    }

    function initAllLists(root) {
      const root$ = root || document;
      root$.querySelectorAll('.filter-widget--update').forEach(initList);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllLists());
    } else {
      initAllLists();
    }

    const sidebar = document.querySelector('.filters-sidebar') || document.querySelector('filters-form');
    if (sidebar) {
      const observerConfig = { childList: true, subtree: true };
      const observer = new MutationObserver((mutations) => {
        const isOwnChange = mutations.every(
          (m) => m.target.nodeType === Node.TEXT_NODE
                ? !!m.target.parentElement?.closest('.filter-show-more-wrap')
                : !!m.target.closest?.('.filter-show-more-wrap')
        );
        if (isOwnChange) return;

        observer.disconnect();
        initAllLists(sidebar);
        setTimeout(() => observer.observe(sidebar, observerConfig), 0);
      });
      setTimeout(() => observer.observe(sidebar, observerConfig), 0);
    }
  })();
  if (!customElements.get('product-compare-button')) {
    customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
      constructor() {
        super();
        
        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }
      
      connectedCallback(){
        this.checkComparelistStatus();
      }
      
      onCompare(){
        event.preventDefault();
        if(!this.dataset.handle) return;
        
        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;
        
        if(!compareList.includes(handle)){
        
          if(compareList.length && compareList.length >= compareLimit){
            comparelistContainer.classList.add('--limit-exceed');
            
            alert(window.additionalStrings.compare.limitExceed);
            return;
          
          } else{
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        
        } else{
          var index = compareList.indexOf(handle);
          
          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));
        
        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if(compareList.length === 0){
          modalOpener.classList.add('hidden');
        
        } else if(compareList.length === 1){
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        
        } else{
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }
        
        if(comparelistOrganizer){
          comparelistOrganizer.innerText = compareList.length;
        }
        
        this.checkComparelistStatus();
      }
      
      checkComparelistStatus(){
        if(!this.dataset.handle) return;
        
        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        
        allBtns.forEach(btn => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');
          
          if(compareList.includes(handle)){
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
          
          } else{
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
          }
        });
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const compareListStorage = localStorage.getItem('comparelist');
    const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
    if(!comparelistContainer) return;
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
    if(compareList.length && compareList.length >= compareLimit){
      comparelistContainer.classList.add('--limit-exceed');
    
    } else{
      comparelistContainer.classList.remove('--limit-exceed');
    }
    
    if(comparelistOrganizer){
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
    
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const msg = url.searchParams.get('contact[Message]');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
      if(popup) popup.open();
    }
  });
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        
        this.bundleContainer = document.querySelector('[data-bundle-product-wrapper]');
        if(this.bundleContainer) this.bundleContainer.classList.add('visually-hidden');
      }

      connectedCallback() {
        this.empty = true;
        
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.empty = false;
                this.innerHTML = recommendations.innerHTML;
                
                if(!recommendations.innerHTML.includes('<product-card')){
                  let recommendationAncestor = this.parentElement;
                  
                  while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                    recommendationAncestor = recommendationAncestor.parentElement;
                  }
                  
                  if(recommendationAncestor){
                    recommendationAncestor.classList.add('hidden');
                  }
                }
              
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              if(this.empty){
                if(this.bundleContainer) this.bundleContainer.classList.add('hidden');
                this.parentElement.classList.add('hidden');
                return;
              }
              if(this.bundleContainer) this.bundleContainer.classList.remove('visually-hidden');
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    });
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }
  const fetchAtc = (sections, config, element, loaderSelector) => {
    this.error = true;
    togglerLoader(true, loaderSelector);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        togglerLoader(false, loaderSelector);
        if(!this.error){
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) element.recipientForm.resetRecipientForm();
        }
      }
    );
  }
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
  }
  const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      const textContainer = atcBtn.querySelector('[data-atc-text]');
      if(variant.available){
        textContainer.innerText = textContainer.dataset.textAvail;
        atcBtn.removeAttribute('disabled');
        atcBtn.classList.remove('--disabled');
        return;
      }
      textContainer.innerText = textContainer.dataset.textSold;
      atcBtn.setAttribute('disabled', '');
      atcBtn.classList.add('--disabled');
    });
  }
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    const textContainer = btn.querySelector('[data-atc-text]');
    textContainer.innerText = textContainer.dataset.textUnavail;
    btn.setAttribute('disabled', '');
  }
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(!arr) return;
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      imageContainer.classList.remove('.imageContainer');
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          splide.go(slide[0].index);
          break;
      }
    });
  }
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
    togglerLoader(true, loaderSelector);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        togglerLoader(false, loaderSelector);
      }
    );
  }
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  }
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  }
  class VariantPill extends HTMLElement {
    constructor() {
      super();
    
      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }
    
    onInputChange(){
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }
    
    setVariantOptions(value){
      const parent = document.querySelector(this.dataset.parent);
      const mainParent = document.querySelector(this.dataset.mainParent);
      const errElem = document.querySelector(this.dataset.errorSelector);
      if(!parent) return;
      if(mainParent.hasAttribute('data-bundle-included')){
        const bundleCalculator = document.querySelector('bundle-calculator');
        mainParent.removeAttribute('data-bundle-included');
        bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
      }
      if(errElem) errElem.classList.add('hidden');
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('variant-pill');
      pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if(this.dataset.checkSets === 'true'){
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find(set => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
    }
    
    setOptions(elems, set){
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(elem => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
          elem.classList.remove('disabled');
          labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
      });
    }
  }
  if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    
      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    
      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }
    
      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }
    
      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }
    
      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }
    
      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      this.recipientForm = this.form.querySelector('recipient-form');
      this.submit = this.onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }

    onAddToCart(event){
      event.preventDefault();
      this.error = false;
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetchAtc(secArr, config, this, this.dataset.loader);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class AtcBundleToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onBundleSubmit = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.mainParent);
        const btnSpan = parent.querySelector('[data-atc-text]');
        const formData = new FormData(this.form);
        const mediaElement = document.querySelector(this.dataset.gallery);
        const bundleCalculator = document.querySelector('bundle-calculator');
        bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
        if(!parent.hasAttribute('data-bundle-included')){
          btnSpan.innerText = btnSpan.dataset.removeText;
          parent.setAttribute('data-bundle-included', '');
          parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
        } else{
          btnSpan.innerText = btnSpan.dataset.textAvail;
          parent.removeAttribute('data-bundle-included');
          parent.removeAttribute('data-bundle-variant');
        }
      };
      this.form.addEventListener('submit', onBundleSubmit);
    }

    onRemoval(){
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      btnSpan.innerText = btnSpan.dataset.textAvail;
      parent.removeAttribute('data-bundle-included');
      parent.removeAttribute('data-bundle-variant');
    }
  }
  if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
  class BundleCalculator extends HTMLElement {
    constructor() {
      super();

      this.arr = [];
      this.list = this.querySelector('[data-thumbnails-list]');
      this.btn = this.querySelector('[data-bundle-atc-btn]');
      if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
    }
    
    init(media, variant, price, comparePrice, removeId = null){
      const createDataset = (id, price, comparePrice, media) => {
        const index = this.arr.findIndex(item => item.variant === id);
        if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
        this.arr.splice(index, 1);
      }
      const updateStats = (price, comparePrice, count) => {
        const bundleNumElement = this.querySelector('[data-num-count]');
        const bundlePriceElement = this.querySelector('[data-bundle-price]');
        const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
        const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
        bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
        if(comparePrice === price){
          bundleComparePriceElement.classList.add('hidden');
        } else{
          bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
          bundleComparePriceElement.classList.remove('hidden');
        }
        if(count === 0){
          bundleNumElement.classList.add('hidden');
          bundleAtcBtn.classList.add('disabled');
          return;
        }
        bundleNumElement.innerText = count;
        bundleNumElement.classList.remove('hidden');
        bundleAtcBtn.classList.remove('disabled');
      }
      const renderDataList = () => {
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        this.resetThumbsList();
        this.arr.forEach(product => {
          const thumbItem = document.createElement("li");
          this.list.appendChild(thumbItem);
          if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
          this.list.appendChild(thumbItem);
          bundlePrice += product.price;
          bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
        });
        updateStats(bundlePrice, bundleComparePrice, this.arr.length);
      }
      if(removeId){
        const index = this.arr.findIndex(item => item.variant === removeId);
        this.arr.splice(index, 1);
        renderDataList();
        return;
      }
      createDataset(variant, price, comparePrice, media);
      renderDataList();
    }

    resetThumbsList(){
      while(this.list.firstChild){
        this.list.removeChild(this.list.firstChild);
      }
    }

    onBundleSubmit(event){
      event.preventDefault();
      const runAtc = () => {
        togglerLoader(true, this.dataset.loaderSelector);
        if(this.arr.length > 0){
          const product = this.arr[0];
          fetchBundleAtc(product);
          return;
        }
        togglerLoader(false, this.dataset.loaderSelector);
        if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
        if(this.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(this.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
      }
      const fetchBundleAtc = (product) => {
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('id', product.variant);
        formData.append('quantity', 1);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
      }
      runAtc();
    }
  }
  if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
  const lineItemUpdate = (line, quantity, sections, parent) => {
    togglerLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        togglerLoader(false);
      }
    );
  }
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }
    
    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }
    
    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  class LineItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback(){
      if(!this.button) return;

      const onRemoval = (event) => {
        event.preventDefault();
        lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
      }
      this.removal = onRemoval.bind(this);
      this.button.addEventListener('click', this.removal);
    }
  }
  if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
  class DropdownToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.button = this.querySelector('[data-btn-toggler]');
      if(!this.button) return;
      const onHandleClick = (event) => {
        event.preventDefault();
        const parent = document.querySelector(this.dataset.parent);
        parent.classList.toggle(this.dataset.activeClass);
      }
      this.handleClick = onHandleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
    }
  }
  if(!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-banners"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  class ScrollingComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.scrolling-component');
      if (!container || !this.querySelector('.scrolling-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('scrolling-component--h-scroll', 'scrolling-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('scrolling-component')) customElements.define('scrolling-component', ScrollingComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-bar"]) return;
  try {
    
  class ScrollingComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.scrolling-component');
      if (!container || !this.querySelector('.scrolling-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('scrolling-component--h-scroll', 'scrolling-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('scrolling-component')) customElements.define('scrolling-component', ScrollingComponent);
  if (!customElements.get('accordion-wrapper')) {
    customElements.define('accordion-wrapper', class AccordionWrapper extends HTMLElement {
      constructor() {
        super();
        
        this.toggle = this.querySelector('summary');
        if(this.toggle) this.toggle.addEventListener('click', this.accordion.bind(this));
      }
      
      accordion(event){
        if(this.dataset.behavior === 'open-close') this.setEventListners();
        if(this.toggle.parentElement.hasAttribute('open') && this.dataset.behavior !== 'open-close') this.keepOpen(event);
        if(!this.toggle.parentElement.hasAttribute('open')) this.closeOther();
      }
      
      closeOther(){
        const allRows = document.querySelectorAll(`#${this.dataset.parent} details`);
        allRows.forEach(toggler => {
          if(toggler.querySelector('summary') === this.toggle && this.dataset.behavior !== 'open-close') return;
          toggler.removeAttribute('open');
        });
      }
      
      keepOpen(event){
        const toggle = event.target.closest('details');
        toggle.removeAttribute('open');
      }
      
      setEventListners(){
        document.body.addEventListener('click', this.hideOutside.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      
      hideOutside(event){
        const target = event.target;
        const boundings = this.querySelector('.collapsible-row_content');
        if (boundings.contains(target) || target === boundings || target.closest('.collapsible-row_content')) return;
        this.closeOther();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.closeOther();
      }
    });
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', class StickyBlock extends HTMLElement {
      constructor() {
        super();
        
        if(!this.dataset.refBlock && !this.dataset.behavior) return;
        this.onLoad = setTimeout(this.initialize.bind(this), 2000);
      }
      
      connectedCallback(){
        document.addEventListener('DOMContentLoaded', function(){this.onload;});
      }
      
      initialize(){
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        
        if(this.behavior){
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', this.onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', this.onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', this.onStackedScroll.bind(this));
              break;
            default:
              console.log('init sticky block');
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if(!this.refBlock) return;
        
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        
        if(this.spacer) this.height = this.refBlock.offsetHeight;
      }
      
      onDownwardScroll(){
        let revealedAttr = false;
        
        if(this.percent){
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = pageHeight * parseFloat(this.percent) / 100;
          this.threshold = threshold;
        }
        
        if(window.scrollY > this.threshold){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      onUpwardScroll(){
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;
        
        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
          
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          this.dropdownClose();
          
          if(window.scrollY < threshold){
            revealedAttr = false;
          }
        }
        
        this.setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      }
      
      onStackedScroll(){
        let revealedAttr = false;
        if(this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if(this.refBoundings.y < window.scrollY){
          revealedAttr = true;
        }
        
        this.setStickyStatus(revealedAttr);
      }
      
      setStickyStatus(revealed){
        if(this.dataset.hideOnEnd === 'true'){
          if((window.innerHeight + window.scrollY) >= this.endBounds){
            this.stickyHide();
            return;
          }
        }
        
        if(revealed){
          this.setAttribute('data-revealed', true);
          if(this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if(this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if(this.height){
            this.style.height = this.height + 'px';
            if(this.dataset.bodyClass) document.body.style.setProperty(this.dataset.cssVariable, this.height + 'px');
          }
          return;
        }
        
        this.stickyHide();
      }
      
      stickyHide(){
        this.setAttribute('data-revealed', false);
        if(this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if(this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if(this.height){
          this.style.removeProperty('height');
          
          if(this.dataset.bodyClass) document.body.style.removeProperty(this.dataset.cssVariable);
        }
      }
      
      dropdownClose(){
        const dropdowns = this.querySelectorAll('dropdown-component');
        if(!dropdowns) return;
        dropdowns.forEach(dropdown => {
          dropdown.close();
        });
      }
    });
  }
  if (!customElements.get('dropdown-component')) {
    customElements.define('dropdown-component', class DropdownComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden === 'true' && screen.width > 767) return;
        this.button = this.querySelector('.dropdown-component_opener:not(.hidden)');
        this.content = this.querySelector('.dropdown-component_wrapper');
        this.onButtonClick = this.toggleDropdown.bind(this);
        this.shareEvent = this.copyToClipboard.bind(this);
        this.shareClose = this.close.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.button.addEventListener('click', this.onButtonClick);

        if(this.dataset.submission === 'true'){
          this.input = this.querySelector('input');
          const itemsArr = this.content.querySelectorAll('.dropdown-component_btn-submit');
          if(!itemsArr) return;
          itemsArr.forEach(item => {item.addEventListener('click', this.onItemClick.bind(this));});
        }
        
        if(this.dataset.sorting === 'true'){
          const itemsArr = this.content.querySelectorAll('.dropdown-component_btn-sort');
          if(!itemsArr) return;
          itemsArr.forEach(item => {item.addEventListener('click', this.onSort.bind(this));});
        }
        
        if(this.dataset.share === 'true'){
          this.elements = {
            successMessage: this.querySelector('.shareMessage'),
            closeButton: this.querySelector('.share-button__close'),
            shareButton: this.querySelector('.share-button__copy'),
            urlInput: this.querySelector('.shareUrl')
          }
          if(navigator.share){
            this.button.removeEventListener('click', this.onButtonClick);
            this.button.addEventListener('click', () => { navigator.share({ url: this.elements.urlInput.value, title: document.title }); });
            return;
          }
        }
        
        this.setIndexing(false);
      }

      toggleDetails(){
        if(!this.dataset.share) return;
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
      }

      copyToClipboard(){
        if(!this.dataset.share) return;
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
        });
        this.elements.closeButton.addEventListener('click', this.shareClose);
      }

      open(){
        this.button.setAttribute('aria-expanded', true);
        this.content.focus();
        this.content.classList.add('dropdown--open');
        const focusables = this.dataset.dropdownLevel === '2' ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]') : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        if(this.dataset.share === 'true'){
          if(!navigator.share){
            this.elements.shareButton.addEventListener('click', this.shareEvent);
          }
        }
        if(!focusables) return;
        this.setIndexing(true, focusables);
      }

      close(){
        if(!this.button) return;
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        if(this.dataset.share === 'true'){
          if(navigator.share){
            this.elements.shareButton.removeEventListener('click', () => { navigator.share(); });
          
          } else{
            this.elements.shareButton.removeEventListener('click', this.shareEvent);
          }
          this.toggleDetails();
        }
        const focusables = this.dataset.dropdownLevel === '2' ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]') : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
        if(!focusables) return;
        this.setIndexing(false, focusables);
      }

      toggleDropdown(event){
        if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
        this.open();
      }

      onBodyClick(event){
        const target = event.target;
        if(this.contains(target) || target === this || target === this.button
          && this.button.getAttribute('aria-expanded') === 'true') return;
        
        if(this.dataset.dropdownLevel === '2'){
          event.stopPropagation();
          this.close();
          return;
        }

        this.close();
      }

      onKeyUp(event){
        if(event.code.toUpperCase() !== 'ESCAPE') return;
        
        if(this.dataset.dropdownLevel === '2'){
          event.stopPropagation();
          this.close();
          return;
        }
        this.close();
        this.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        if(this.input) this.input.value = event.currentTarget.dataset.value;
        if (this.input && form) form.submit();
      }
      
      onSort(event){
        event.preventDefault();
        const sortInput = document.getElementById(this.dataset.inputId);
        let form = document.querySelector('.filters-sidebar filters-form form');
        if(!form) form = document.querySelector('#filters-form');
        if(!sortInput || !form) return;
        const value = event.target.dataset.value;
        const text = event.target.firstChild.textContent;
        this.button.firstChild.textContent = text;
        sortInput.value = value;
        form.dispatchEvent(new Event('input'));
      }
      
      setIndexing(flag, arr = null){
        const focusables = arr ? arr : this.content.querySelectorAll('a[data-level],button[data-level]');
        if(!focusables) return;
        focusables.forEach(element => {
          indexing(flag, element);
        });
        
        function indexing(condition, element){
          if(condition){
            element.removeAttribute('tabindex');
          
          } else{
            element.setAttribute('tabindex', '-1');
          }
        }
      }
    });
  }
  if (!customElements.get('modal-component-toggler')) {
    customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleModal.bind(this));
      }

      open(modal){
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      close(modal){
        modal.close();
      }

      toggleModal(event){
        event.preventDefault();

        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return this.close(modal);
        this.open(modal);
      }
    });
  }
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        
        if(this.dataset.desktopHidden && screen.width > 991) return;
        if(this.dataset.mobileHidden && screen.width < 768) return;
        if(this.dataset.storage === 'true'){
          const keyExists = localStorage.getItem(this.dataset.storageKey);
          if(keyExists === this.dataset.storageValue) return this.remove();
        }
        this.toggler = null;
        this.parent = null;
        this.content = this.querySelector('.modal-component');
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        
        if(this.dataset.compare === 'true'){
          this.elements = {
            counterElement: this.querySelector('.compare-counter'),
            contentBody: this.querySelector('.compare-popup_body'),
            contentGrid: this.querySelector('.compare-popup_grid'),
          }
        }

        if(this.dataset.trigger === 'self'){
          this.open();
        }
      }

      open(toggler = null){
        this.toggler = toggler;
        if(this.dataset.container === 'body'){
          this.parent = this.parentElement;
          document.body.append(this);
        }
        this.setClasses(true);
        if(this.dataset.compare === 'true'){
          this.onContentOpen();
        } else{
          this.content.focus();
          trapFocus(this.content);
        }
        if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
      }

      close(){
        if(this.dataset.container === 'body'){
          if(this.parentNode === document.body) document.body.removeChild(this);
          if(this.parent) this.parent.append(this);
        }
        if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
        this.setClasses(false);
        if(this.toggler) removeTrapFocus(this.toggler);
        this.toggler = null;
        this.parent = null;
        this.setListeners(false);
        if(this.dataset.formReset === 'true'){
          const form = this.querySelector('form');
          if(form) form.reset();
        }
      }

      setClasses(flag){
        if(!flag){
          this.classList.remove('modal--active');
          document.body.classList.remove(`${this.dataset.modal}--modal-active`);
          // Remove overflow-hidden only if no other modals are active
          if (document.querySelectorAll('.modal--active').length === 0) {
            document.body.classList.remove('overflow-hidden');
          }
          return;
        }
        this.classList.add('modal--active');
        document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
      }

      setListeners(flag){
        if(flag){
          this.addEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
        
        } else{
          this.removeEventListener('keyup', this.onKeyUp);
          if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
        }
      }

      onBodyClick(event){
        const target = event.target;
        const boundings = this.querySelector('.modal-component_body');
        if (boundings.contains(target) || target === boundings) return;
        this.close();
      }

      onKeyUp(event){
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
      
      onContentOpen(){
        this.classList.remove('--loaded');
        this.elements.contentBody.classList.add('--show-loader');
        this.elements.contentGrid.innerHTML = '';
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        while (compareList.length < 3) {
          compareList.push('null');
        }
        this.initRenderProcess(compareList);
      }
      
      initRenderProcess(arr){
        if(arr.length){
          const columnCurr = arr[0];
          this.getCompareRender(columnCurr, arr);
          return;
        }
        this.setSameheightRows();
        
        this.elements.contentBody.classList.remove('--show-loader');
        this.classList.add('--loaded');
        this.content.focus();
        trapFocus(this.content);
      }
      
      getCompareRender(handle, all){
        let fetchUrl = `${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`;
        if (handle === 'null' || !handle) {
          fetchUrl = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currHtml = html.querySelector('.compare-product_column');
            
            if (currHtml) {
              this.setAppendColumn(currHtml);
            }
        })
        .finally(() => {
          this.setCurrentArr(all);
        });
      }
      
      setAppendColumn(html){
        this.elements.contentGrid.append(html);
      }
      
      setCurrentArr(norm){
        const nextColumnsArr = norm.slice(1);
        this.initRenderProcess(nextColumnsArr);
      }
      
      setSameheightRows(){
        const rows = this.querySelectorAll('.compare-product_row');
        let height = 0;
        
        for (let i = 0; i < rows.length; i++) {
          const elementHeight = rows[i].offsetHeight;
          
          if(elementHeight > height){
            height = elementHeight;
          }
        }
        
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.setProperty('--cp-same-height', height + 'px');
        }
      }
    });
  }
  if (!customElements.get('search-typing-placeholder')) {
    customElements.define('search-typing-placeholder', class SearchTypingPlaceholder extends HTMLElement {

      static STATIC_PREFIX   = 'Recherchez ';
      static SUFFIXES        = ['un produit...', 'une collection...', 'un jeu...'];
      static TYPING_SPEED    = 80;
      static ERASING_SPEED   = 40;
      static PAUSE_AFTER     = 1800;
      static PAUSE_BEFORE    = 400;

      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        if (!this.input) return;

        this.suffixIndex = 0;
        this.charIndex   = 0;
        this.isErasing   = false;
        this.isPaused    = false;
        this.timeoutId   = null;

        // Pause only when the user has actually typed something
        this.onInput = () => {
          if (this.input.value !== '') {
            this.isPaused = true;
            clearTimeout(this.timeoutId);
          } else {
            // Field was cleared — resume animation
            this.isPaused = false;
            this.tick();
          }
        };

        // When field is blurred empty (e.g. after reset), make sure animation is running
        this.onBlur = () => {
          if (this.input.value.trim() === '' && this.isPaused) {
            this.isPaused = false;
            this.tick();
          }
        };

        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('blur',  this.onBlur);

        this.input.placeholder = SearchTypingPlaceholder.STATIC_PREFIX;
        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timeoutId);
        if (this.input) {
          this.input.removeEventListener('input', this.onInput);
          this.input.removeEventListener('blur',  this.onBlur);
        }
      }

      tick() {
        if (this.isPaused) return;
        const suffix = SearchTypingPlaceholder.SUFFIXES[this.suffixIndex];

        if (!this.isErasing) {
          this.charIndex++;
          this.input.placeholder = SearchTypingPlaceholder.STATIC_PREFIX + suffix.slice(0, this.charIndex);
          if (this.charIndex === suffix.length) {
            this.isErasing = true;
            this.timeoutId = setTimeout(() => this.tick(), SearchTypingPlaceholder.PAUSE_AFTER);
          } else {
            this.timeoutId = setTimeout(() => this.tick(), SearchTypingPlaceholder.TYPING_SPEED);
          }
        } else {
          this.charIndex--;
          this.input.placeholder = SearchTypingPlaceholder.STATIC_PREFIX + suffix.slice(0, this.charIndex);
          if (this.charIndex === 0) {
            this.isErasing   = false;
            this.suffixIndex = (this.suffixIndex + 1) % SearchTypingPlaceholder.SUFFIXES.length;
            this.timeoutId   = setTimeout(() => this.tick(), SearchTypingPlaceholder.PAUSE_BEFORE);
          } else {
            this.timeoutId = setTimeout(() => this.tick(), SearchTypingPlaceholder.ERASING_SPEED);
          }
        }
      }
    });
  }
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.searchTerm = '';
      this.cachedResults = [];
      this.abortController = new AbortController();
      // this.resetButton = this.querySelector('button[type="reset"]');
      this.elements = {
        input: this.querySelector('input[type="search"]'),
        resetBtn: this.querySelector('.search-bar_reset-btn'),
        form: this.querySelector('form'),
        resultsContainer: this.querySelector('.search_results-container'),
        loader: this.querySelector('.search-bar_loader'),
        productResultsContainer: this.querySelector('.search-tab-products_results'),
        collectionResultsContainer: this.querySelector('.search-tab-collections_results'),
        articleResultsContainer: this.querySelector('.search-tab-articles_results')
      }
      
      this.tabsetElements = {
        tabItems: this.querySelectorAll('.search-bar_tabs-list > li > a'),
        tabContents: this.querySelectorAll('.search-tab_content')
      }
      
      this.dataSelectors = {
        products: '.--search-tab-products-data',
        collections: '.--search-tab-collections-data',
        articles: '.--search-tab-articles-data'
      }

      if (this.elements.input) {
        // this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.elements.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this))
      }
      
      this.elements.input.addEventListener('click', this.onInputClick.bind(this));
      
      this.tabsetElements.tabItems.forEach(opener => {
        opener.addEventListener('click', this.openTabContent.bind(this));
      });
      
      document.body.addEventListener('click', this.hideOutside.bind(this));
      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.closeResults();
      });
      
      if(this.elements.resetBtn) this.elements.resetBtn.addEventListener('click', this.resetForm.bind(this));
    }
    
    onInputClick(){
      if(this.cachedResults.length && this.elements.input.value.length > 0){
        this.classList.add('--show-search-results');
      }
    }
    
    hardSubmit(){
      this.elements.form.submit();
    }

    onChange() {
      const inputValueTerm = this.elements.input.value.replace(/\s/g, "");
      
      if(inputValueTerm.length > 0){
        this.searchTerm = this.elements.input.value.trim();
        
        const term = {searchTerm: this.searchTerm};
        
        if (!this.cachedResults || !this.cachedResults.some(key => key.searchTerm === term.searchTerm)) {
          this.elements.form.classList.add('--show-loader');
          
          this.fetchSearchResults(this.searchTerm);
          
          return;
        }
        
        this.getCachedResults(term, this.cachedResults);
        
        return;
      }
      
      this.resetResults();
    }
    
    fetchSearchResults(search){
      fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          search
        )}&section_id=predictive-search&resources[type]=${this.dataset.searchTypes}`,
        { signal: this.abortController.signal }
      )
      .then((response) => {
        
        if (!response.ok) {
          var error = new Error(response.status);
          console.log(error);
        }

        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        const searchObj = {
          searchTerm: this.searchTerm,
          contentHtml: html
        }
        this.cachedResults.push(searchObj);
        
        this.updateTabsData(html);
        
        this.elements.form.classList.remove('--show-loader');
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
      })
    }
    
    getCachedResults(data, cache){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.searchTerm === data.searchTerm);
      
      this.updateTabsData(cachedResults.contentHtml);
    }
    
    updateTabsData(newHtml){
      this.tabsetElements.tabItems.forEach(items => {
        items.classList.remove('active');
      });
      
      this.tabsetElements.tabContents.forEach(tabs => {
        tabs.classList.remove('--active-tab');
      });
      
      const productsListHtml = newHtml.querySelector(this.dataSelectors.products);
      const collectionsListHtml = newHtml.querySelector(this.dataSelectors.collections);
      const articlesListHtml = newHtml.querySelector(this.dataSelectors.articles);
      
      if(productsListHtml) this.getHtmlToRender(this.elements.productResultsContainer, productsListHtml);
      if(collectionsListHtml) this.getHtmlToRender(this.elements.collectionResultsContainer, collectionsListHtml);
      if(articlesListHtml) this.getHtmlToRender(this.elements.articleResultsContainer, articlesListHtml);
      
      this.dataCheckToActiveTab(productsListHtml, collectionsListHtml, articlesListHtml);
      
      if(this.elements.resultsContainer) this.elements.resultsContainer.classList.remove('--show-loader');
      this.classList.add('--show-search-results');
      
      const hardSubmitBtn = this.querySelectorAll('.predictive-search_show-btn');
      if(hardSubmitBtn){
        hardSubmitBtn.forEach(btnSubmit => {
          btnSubmit.addEventListener('click', this.hardSubmit.bind(this));
        });
      }
    }
    
    dataCheckToActiveTab(product, collection, articles){
      if(product){
        
        if(!product.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[0].classList.add('active');
          this.tabsetElements.tabItems[0].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[0].classList.add('--active-tab');
        }
      }
      
      if(collection){
        
        if(product.classList.contains('--no-search-data') && !collection.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[1].classList.add('active');
          this.tabsetElements.tabItems[1].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[1].classList.add('--active-tab');
        }
      }
      
      if(articles){
        
        if(product.classList.contains('--no-search-data') && collection.classList.contains('--no-search-data')){
          this.tabsetElements.tabItems[2].classList.add('active');
          this.tabsetElements.tabItems[2].setAttribute('aria-selected', true);
          this.tabsetElements.tabContents[2].classList.add('--active-tab');
        }
      }
    }
    
    getHtmlToRender(selector, newHtml){
      selector.innerHTML = newHtml.outerHTML;
    }
    
    openTabContent(){
      event.preventDefault();
      
      this.tabsetElements.tabItems.forEach(items => {
        items.classList.remove('active');
        items.setAttribute('aria-selected', false);
      });
      
      this.tabsetElements.tabContents.forEach(tabs => {
        tabs.classList.remove('--active-tab');
      });
      
      const url = new URL(event.target.href);
      const ref = url.hash.substring(1)
      const tabc = document.getElementById(ref);
      
      event.target.classList.add('active');
      event.target.setAttribute('aria-selected', true);
      tabc.classList.add('--active-tab');
    }
    
    closeResults(){
      this.classList.remove('--show-search-results');
    }
    
    hideOutside(){
      const target = event.target;
      if (target != this && target.id != 'search-bar' && (!this.contains(event.target)) && this.classList.contains('--show-search-results')){
        this.closeResults();
      }
    }
    
    resetResults(){
      this.classList.remove('--show-search-results');
      this.elements.productResultsContainer.innerHTML = '';
      this.elements.collectionResultsContainer.innerHTML = '';
    }
    
    resetForm(){
      event.preventDefault();
      
      this.closeResults();
      this.elements.form.reset();
      this.elements.productResultsContainer.innerHTML = '';
      this.elements.collectionResultsContainer.innerHTML = '';
      
      this.elements.input.focus();
    }
  }
  if(!customElements.get('search-form')) customElements.define('search-form', SearchForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-list"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      // Stop all other playing/loaded media before starting this one
      stopOtherReels(this);

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();
})();
